import { Component } from "react";
import '../IpPatientDetails.css';
import {
  Box, Paper, TextField, Button, Stack, Tooltip, Grid, IconButton, Menu, FormControl, Select,
  MenuItem, Autocomplete, Chip, Typography, ButtonGroup, InputLabel, Table, TableBody,
  TableHead, TableRow, TableCell, TableContainer, Collapse,
  OutlinedInput, Modal, ListItem, ListItemText, Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  Checkbox,
  DialogActions
} from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import { withTranslation } from 'react-i18next';
import { CommonPatientDetails, CommonPatientCard, CommonDeleteButton, CommonEditButton, DeletePopup, CommonPopUp, ConsultantPatientCard, HighAlertDrugPopup } from "../../../../../Components/Common Components/CommonComponents";
import CommonValidation from "../../../../../Components/CommonFunctions/CommonValidation";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTime } from "luxon";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ImagePaths } from "../../../../../Utility/ImagePaths";
import { Colors } from "../../../../../Styles/Colors";
import ToastMsg from '../../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from "../../../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../../../Utility/API/Serviceurls";
import { getCachevalue, localGetItem } from "../../../../../Utility/Services/CacheProviderService";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { MaenList, DurationsList, DurationCounts, IP_routeList, Taper_Med_Dosages, Taper_Med_Frequency, Medication_dosages, Prescription_Days } from '../../../../../Utility/Constants';
import { t } from "i18next";
import { CheckAccessFunc, debounce, formatDate } from "../../../../../Components/CommonFunctions/CommonFunctions";
import Loader from '../../../../../Components/Loader';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import CommonDatePicker from "../../../../../Components/Common Components/CommonDatePicker";
import DeleteIcon from "@material-ui/icons/DeleteOutlined";


const buckets = {
  Inprogress: "data",
  Transmitted: "data",
  Saved: "data",
  Billed: "rtnData",
  Cancelled: "calData",
};

const ITEM_HEIGHT = 30;
let today = new Date();
const multi_option = [
  { value: "Medication", label: "Medication" },
];

const titleMap = {
  Add: "Add New Template",
  rename: "Rename Template",
  delete: "Delete Template",
};

const disallowed = new Set(["SOS", "STAT"]);

class Medication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      medicationDetails: [],
      patientData: {},
      attenderData: {},
      pharmaData: [],
      pharma_name: "",
      pharma_id: null,
      brandnameList: [],
      genericList: [],
      mediItem: {},
      tapperItem: {},
      frequentDrugs: [],
      open: false,
      duration_mode: "Day(s)",
      duration: null,
      isTapper: false,
      instruction: "",
      tapperDuration_mode: "Day(s)",
      tapperDuration: "",
      tapperStartDate: today,
      tapperUnit_typ: "",
      tapperReduced_typ: "mg",
      tapperDetails: [],
      tapperFrequency: "",
      selectedEditIndex: null,
      morning: 0,
      afternoon: 0,
      evening: 0,
      night: 0,
      quantity: null,
      brand_name: "",
      medication_id: null,
      selectedRow: null,
      isSelected: false,
      anchorEl: null,
      isHistoryClicked: false,
      selectedOption: "",
      selectedDetails: [],
      newSelectedDetails: [],
      selectedIndex: -1,
      historyData: [],
      focusError: "",
      isEdit: false,
      drug_name: "",
      drug_ms_id: null,
      current_page: 0,
      rowsPerPage: 10,
      withOutAppointment: {},
      showSuccessResponse: false,
      showErrorResponse: false,
      responseMessage: "",
      ExternalDrug: "",
      externalBrandName: "",
      externalGenName: "",
      externalDosageType: "",
      externalDosStrength: "",
      externalRoute: "",
      mediRouteOther: "",
      externalRouteOther: "",
      clinic_id: JSON.parse(localGetItem("loggedInUserInfo"))?.clinic_id ||
        JSON.parse(localGetItem('SelectedDoctorClinicId')) || null,
      ExternalDrugList: [],
      genericSuggList: [],
      dupExternalDrugList: [],
      fo_external_drug_id: null,

      // new Left Screen states
      page: 0,
      pageSize: 10,
      newMedicationRequestList: [],
      newMedicationReturnList: [],
      drug_search: '',
      transmitData: [],
      returnData: [],
      rtnPageSize: 10,
      rtnPage: 0,
      calPage: 0,
      calPageSize: 10,
      newMedicationCancelledList: [],
      selectedBtn: 'request',

      //dropdown
      Selected_days: [],
      fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      dateIndex: 0,
      templateList: [],
      selectedTemplateName: null,
      openPopupAddNew: false,
      templateName: '',
      tempType: '',
      templateLoad: false,
      deleteTemplateName: {},
      deletePopup: false,
      deleteLoad: false,
      deletedPopup: false,
      selectedDrug: '',
      is_high_alert: false,
      is_look_alike: false,
      is_sound_alike: false,
      highAlert: false,
      lookAlikeDrugs: [],
      SoundAlikeDrugs: [],
      highAlertData: [],
      onlyWarning: false,
      AllData: [],
      fromTemplate: false,
      enable_drug_alert: false,
      nurseList: [],
      selectedNurse: null,
      nurseName: "",
      prescriptionUsage: [],
      selectedUsage: null,
      openAddNew: false,
      prescUsage: null,
      postUsageLoad: false,
      showRecallDialog: false,
      recallSelectedIds: [],
      recallReason: '',
      recallMedicationList: [],
      recallIsAllSelected: false,
    }
    this.dobounceApiSearch = debounce(this.getExternalDrugSearchList, 500)
    this.debounceBrandName = debounce(this._getBrandList, 500)
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: '',
      showSuccessResponse: false,
      showErrorResponse: false,
      responseMessage: ''
    })
  }

  componentDidMount() {
    let patientDetails = getCachevalue("IppatientData")
    let patients = JSON.parse(patientDetails)
    let appointmentDetail = getCachevalue("withoutAppointment");
    let details = JSON.parse(appointmentDetail);
    let drugSearch = localGetItem('drug_search') !== 'undefined' ? JSON.parse(localGetItem('drug_search')) : 1;
    let enable_drug_alert = localGetItem('enable_drug_alert') ? JSON.parse(localGetItem('enable_drug_alert')) : false;
    this.setState({
      drug_search: drugSearch,
      patientData: patients,
      enable_drug_alert: enable_drug_alert,
      ...(details?.patient_id === patients?.patient_id && { withOutAppointment: details })
    }, () => {
      this.getPatientData();
      this._getPharmaList();
      this.getNurseList();
      // this._getIpMedicationDetails();
    });
    this.getTemplateList();
    // this.getFrequentDrugInPharma();
    this.getPresctiptionUsageList(); 
  }

  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }

  //handle for dropdown 
  DropdownHandleChange = (event) => {
    const {
      target: { value },
    } = event;
    this.setState({
      Selected_days: typeof value === 'string' ? value.split(',') : value,
    })

  }


  convertDayToNumber = (day) => {
    switch (day) {
      case "Sunday":
        return 0;
      case "Monday":
        return 1;
      case "Tuesday":
        return 2;
      case "Wednesday":
        return 3;
      case "Thursday":
        return 4;
      case "Friday":
        return 5;
      case "Saturday":
        return 6;
      default:
        return null;
    }
  };

  convertNumberToDay = (number) => {
    switch (number) {
      case 0:
        return "Sunday";
      case 1:
        return "Monday";
      case 2:
        return "Tuesday";
      case 3:
        return "Wednesday";
      case 4:
        return "Thursday";
      case 5:
        return "Friday";
      case 6:
        return "Saturday";
      default:
        return null;
    }
  };

  GetIpAdmissionId = () => {
    return this.state.patientData?.id || this.state.withOutAppointment?.ip_admission_id || this.state.patientData?.ip_admission_id || (() => { try { const j = JSON.parse(getCachevalue('IppatientData') || 'null'); return j?.id || j?.ip_admission_id } catch { return null } })() || null;
  }


  getPatientData = () => {
    let admission_id = this.state.patientData?.id || this.props?.ip_admission_id || this.state.withOutAppointment?.ip_admission_id;
    let url = `${(localGetItem('isNewBilling') === "false" ? Serviceurls.IP_PATIENT_DETAILS : Serviceurls.IP_PATIENT_DETAILS_NEW)}?admission_id=${admission_id}`;
    if (this.props.is_From_IpNotes && this.state.clinic_id) {
      url = `${url}&clinic_id=${this.state.clinic_id}`
    }
    try {
      RestAPIService.getAll(url)
        .then((response) => {
          if (response.data.status === "success") {
            this.setState({
              attenderData: response.data.data[0]
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.responseSuccessErrorMessage(error.response.data.message, false)
          } else {
            this.responseSuccessErrorMessage(error.message, false)
          }
        })
    } catch (error) {
      this.responseSuccessErrorMessage(error.message, false)
    }
  }

  _getPharmaList = () => {
    this.setState({
      pharmaData: []
    })
    try {
      let url = Serviceurls.FO_IP_PHARMALIST_GET;
      if (this.props.is_From_IpNotes && this.state.clinic_id) {
        url = `${url}?clinic_id=${this.state.clinic_id}`
      }
      RestAPIService.getAll(url)
        .then(response => {
          if (response.data.status === "success") {
            this.setState({
              pharmaData: response.data.data,
              pharma_name: response.data.data[0].pharmacy_name,
              pharma_id: response.data.data[0].pharmacy_id
            }, () => {
              if (this.state.pharma_id) {
                this.getFrequentDrugInPharma()
                this._getIpMedicationDetails();
              }
            });
          }
        })
        .catch(error => {
          if (error?.response?.data?.status === "fail") {
            this.responseSuccessErrorMessage(error.response.data.message, false);
          }
        });
    } catch (e) {
      this.responseSuccessErrorMessage(e.message, false);
    }
  }

  _getBrandList = (searchKey) => {
    const { t } = this.props;
    this.setState({
      brandnameList: []
    })
    // if ((brand_name || searchKey) && this.state.pharma_id) {
    if (searchKey && this.state.pharma_id) {
      try {
        let params = ''
        if (+this.state.drug_search === 1) {
          params = `${Serviceurls.FO_IP_BRANDNAMELIST_GET}?pharmacy_id=${this.state.pharma_id ? this.state.pharma_id : null}&brand_name=${encodeURIComponent(searchKey)}`
        } else if (+this.state.drug_search === 2) {
          params = `${Serviceurls.FO_IP_BRANDNAMELIST_GET}?pharmacy_id=${this.state.pharma_id ? this.state.pharma_id : null}&brand_name=&generic_name=${encodeURIComponent(searchKey)}`
        } else {
          params = `${Serviceurls.FO_IP_BRANDNAMELIST_GET}?pharmacy_id=${this.state.pharma_id ? this.state.pharma_id : null}&brand_name=&generic_name=&search_key=${searchKey}`
        }
        RestAPIService.getAll(params)
          .then(response => {
            if (response.data.status === "success") {
              let data = response.data.data
              let uniqueArray = data?.filter((item, index, self) =>
                index === self.findIndex((t) => (
                  t.drug_name === item.drug_name
                ))
              );
              this.setState({ brandnameList: uniqueArray });
            }
          })
          .catch(error => {
            if (error?.response?.data?.status === "fail") {
              this.responseSuccessErrorMessage(error.response.data.message, false);
            }
          });
      } catch (e) {
        this.responseSuccessErrorMessage(e.message, false);
      }
    }
  }

  _getBrandDetails = (brandName, genericName) => {
    let states = this.state;
    this.setState({
      genericList: []
    })
    try {
      let params = ''
      // let brandName = states["mediItem"]["brand_name"] ? states["mediItem"]["brand_name"] : ""
      // let genericName = states["mediItem"]["generic_name"] ? states["mediItem"]["generic_name"] : ""
      if (+this.state.drug_search === 1) {
        params = `${Serviceurls.FO_IP_BRANDDETAILS_GET}?pharmacy_id=${this.state.pharma_id ? this.state.pharma_id : null}&drug_name=${encodeURIComponent(brandName)}`
      } else {
        params = `${Serviceurls.FO_IP_BRANDDETAILS_GET}?pharmacy_id=${this.state.pharma_id ? this.state.pharma_id : null}&drug_name=${encodeURIComponent(brandName)}&generic_name=${encodeURIComponent(genericName)}`
      }
      RestAPIService.getAll(params)
        .then(response => {
          if (response.data.status === "success") { 
            const list = response.data.data;

            const hasHighAlert = list.some(item => (item.is_high_alert === true || item.is_look_alike === true || item.is_sound_alike === true));
            if (hasHighAlert && this.state.enable_drug_alert) {
              this.setState({
                selectedDrug: list[0]['drug_name'] || '',
                is_high_alert: list[0]['is_high_alert'] || false,
                is_look_alike: list[0]['is_look_alike'] || false,
                is_sound_alike: list[0]['is_sound_alike'] || false,
                lookAlikeDrugs: list[0]['look_alike_drugs'] || [],
                SoundAlikeDrugs: list[0]['sound_alike_drugs'] || [],
                highAlertData: list,
              }, () => {
                this.setState({
                  highAlert: true
                })
              });
              return;
            }
            this._handleBrandDetailsResponse(list);
          }
        })
        .catch(error => {
          if (error?.response?.data?.status === "fail") {
            this.responseSuccessErrorMessage(error.response.data.message, false);
          }
        });
    } catch (e) {
      this.responseSuccessErrorMessage(e.message, false);
    }
  }

  _handleBrandDetailsResponse = (list) => {
    let states = this.state;
    if (list.length === 1) {
      const dosage_type = (list[0]['dosage_type'] || '').toUpperCase();
      const strength = list[0]['drug_strength'] || '';
      const numericAlone = strength.match(/(\d+)/);

      states["mediItem"]["drug_ms_id"] = list[0]["drug_ms_id"];
      states["mediItem"]["generic_name"] = list[0]["generic_name"];
      states["mediItem"]["dosage_type"] = list[0]["dosage_type"];
      states["mediItem"]["dosage_strength"] = list[0]["drug_strength"];
      states["mediItem"]["stock_in_quantity"] = list[0]["stock_in_quantity"];
      states["tapperItem"]["unit"] = (
        dosage_type === "STEROID TABLETS" ? numericAlone?.[0] :
          (dosage_type === "DROP" || dosage_type.toLowerCase().includes('drop') ? 1 : "")
      );
      states["mediItem"]["Selected_days"] = list[0]['Selected_days']
        ? list[0]['Selected_days'].map(item => this.convertNumberToDay(item))
        : [];

      this.setState({
        states,
        tapperUnit_typ:
          dosage_type === "STEROID TABLETS" ? "mg" :
            (dosage_type.includes("DROP") ? "Drop(s)" : ""),
        isTapper:
          dosage_type === "STEROID TABLETS" ||
          dosage_type.includes("DROP")
      });
    } else {
      this.setState({ genericList: list });
    }
  };

  getFrequentDrugInPharma = () => {
    this.setState({
      frequentDrugs: []
    })
    try {
      RestAPIService.getAll(`${Serviceurls.FO_IP_FREQUENTDRUG}?pharmacy_id= ${this.state.pharma_id ? this.state.pharma_id : ""}`)
        .then(response => {
          if (response.data.status === "success") {
            this.setState({
              frequentDrugs: response.data.data,
            });
          }
        })
        .catch(error => {
          if (error?.response?.data?.status === "fail") {
            this.responseSuccessErrorMessage(error.response.data.message, false);
          }
        });
    } catch (e) {
      this.responseSuccessErrorMessage(e.message, false);
    }
  }

  FilterDate = (from, to, index) => {
    this.setState({
      fromDate: from,
      toDate: to,
      dateIndex: index
    }, () => {
      this._getIpMedicationDetails()
    })
  }

  generateUrl = () => {
    let admission_id = this.state.patientData?.id || this.props?.ip_admission_id || this.state.withOutAppointment?.ip_admission_id;
    let url = `${Serviceurls.IP_MEDICATION_GET}?ip_admission_id=${admission_id}&pharmacy_id=${this.state.pharma_id}&from_date=${this.state.dateIndex === 0 ? "" : this.state.fromDate}&to_date=${this.state.dateIndex === 0 ? "" : this.state.toDate}`;
    if (this.props.is_From_IpNotes && this.state.clinic_id) {
      url = `${url}&clinic_id=${this.state.clinic_id}`
    }
    return url;
  }

  _getIpMedicationDetails = (skipCheck = false) => {
    this.setState({
      medicationDetails: [],
      current_page: 0,
      rowsPerPage: 10
    })
    const url = this.generateUrl();
    try {
      this.setState({ loading: true })
      RestAPIService.getAll(url)
        .then(response => {
          if (response.data.status === "success") {
            const allData = response.data.data || [];
            const highAlertData = allData.filter(item =>
              item.is_high_alert === true ||
              item.is_look_alike === true ||
              item.is_sound_alike === true
            );

            // if (highAlertData.length > 0 && !skipCheck && this.state.fromTemplate && this.state.enable_drug_alert) {
            //   this.setState({
            //     highAlert: true,
            //     onlyWarning: true,
            //     AllData: allData
            //   });

            //   return
            // }

            const grouped = (response.data.data || []).reduce((acc, item) => {
              const key = buckets[item?.medication_status];
              if (key) acc[key].push(item);
              return acc;
            }, { data: [], rtnData: [], calData: [] });
            const { data, rtnData, calData } = grouped;

            this.setState({
              medicationDetails: response.data.data,
              newMedicationRequestList: JSON.parse(JSON.stringify(data)),
              newMedicationReturnList: JSON.parse(JSON.stringify(rtnData)),
              newMedicationCancelledList: JSON.parse(JSON.stringify(calData)),
              loading: false,
              fromTemplate: false
            }, () => {
              this.state.medicationDetails.forEach((item, i) => {
                item["index"] = i
                item["line_items"] = item["line_items"]?.map((list, index) => ({ ...list, "already_return_quantity": list?.return_quantity, "return_quantity": null }))
              })
            }
            );
          }
        })
        .catch(error => {
          this.setState({ loading: false, fromTemplate: false })
          if (error?.response?.data?.status === "fail") {
            this.responseSuccessErrorMessage(error.response.data.message, false);
          }
        });
    } catch (e) {
      this.setState({ loading: false, fromTemplate: false })
      this.responseSuccessErrorMessage(e.message, false);
    }
  }

  getTemplateList = () => {
    try {
      RestAPIService.getAll(`${Serviceurls.IP_MEDICATION_TEMPLATE_GET}?clinic_id=${this.state.clinic_id}`)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              templateList: response?.data?.data || [],
            });
          }
        }).catch((error) => {
          this.responseSuccessErrorMessage(error?.response?.data?.message || error.message, false)
        })
    } catch (error) {
      this.responseSuccessErrorMessage(error.message, false)
    }
  }

  getMedicationPrint = () => {
    try {
      const url = this.generateUrl();
      RestAPIService.getAll(`${url}&export_type=pdf`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          this.responseSuccessErrorMessage(error.response.data.message, false);
        })
    } catch (error) {
      this.responseSuccessErrorMessage(t("PrintError"), false);
    }
  }

  _getHistoryDetails = (id) => {
    if (id) {
      this.setState({
        historyData: [],
      })
      try {
        RestAPIService.getAll(`${Serviceurls.FO_IP_HISTORY}?condition=medication&row_id=${id ? id : null}`)
          .then(response => {
            if (response.data.status === "success") {
              this.setState({
                historyData: response.data.data,
              });
            }
          })
          .catch(error => {
            if (error?.response?.data?.status === "fail") {
              this.responseSuccessErrorMessage(error.response.data.message, false);
            }
          });
      } catch (e) {
        this.responseSuccessErrorMessage(e.message, false);
      }
    }
  }

  highAlertpopupConfirm = () => {
    const { highAlertData } = this.state;
    this.setState({ highAlert: false }, () => {
      this._handleBrandDetailsResponse(highAlertData);
    });
  }

  highAlertpopupOk = () => {
    this.setState({ highAlert: false, AllData: [], onlyWarning: false, fromTemplate: false }, () => {
      this._getIpMedicationDetails(true)
    });
  }

  highAlertpopupClose = () => {
    let states = this.state
    states["mediItem"]["brand_name"] = ''
    states["mediItem"]["drug_ms_id"] = null;
    states["mediItem"]["generic_name"] = "";
    states["mediItem"]["dosage_type"] = "";
    states["mediItem"]["dosage_strength"] = "";
    states["tapperItem"]["unit"] = "";
    states["tapperUnit_typ"] = "";
    states["tapperReduced_typ"] = "mg";
    states["tapperDetails"] = "";
    states["isTapper"] = false;
    this.setState({
      states,
      highAlert: false,
      highAlertData: [],
    })
  }

  getNurseList = () => {
    try {
      RestAPIService.getAll(Serviceurls.FO_STAFF_LIST+ `?clinic_id=${this.state.clinic_id}`)
        .then((response) => {
          if (response.data.status === "success") {
            // Map the API response to match your expected structure
            const formattedNurseList = response.data.data.map(nurse => ({
              nurse_id: nurse.staff_id,  // Map staff_id to nurse_id
              nurse_name: nurse.nurse    // Map nurse to nurse_name
            }));

            this.setState({
              nurseList: formattedNurseList
            }, () => {
              if (this.state.nurseList?.length && localGetItem("NurseId") && !this.state?.selectedNurse?.nurse_id) {
                let nurseId = JSON.parse(localGetItem("NurseId"))
                let nurseData = this.state.nurseList.find((item) => item.nurse_id === nurseId)
                this.setState({
                  selectedNurse: nurseData,
                  nurseName: nurseData,
                })
              }
            });
          }
        }).catch((error) => {
          console.error('Error fetching nurse list:', error);
          this.setState({ nurseList: [] });
          this.responseSuccessErrorMessage(error?.response?.data?.message || error.message || 'Failed to fetch nurse list', false);
        })
    } catch (error) {
      console.error('Exception in getNurseList:', error);
      this.setState({ nurseList: [] });
      this.responseSuccessErrorMessage(error.message, false);
    }
  }

  responseSuccessErrorMessage(message, type) {
    this.setState({
      showSuccessResponse: message ? type : false,
      showErrorResponse: message ? !type : false,
      responseMessage: message
    })
  }

  // left table start

  _getDetails = (data, basedOn) => {
    let result = "";
    data.length > 0 && data.forEach(element => {
      result = result ? (`${result},  ${element[basedOn]}`) : `${element[basedOn]}`
    });
    return result;
  }

  getTapperList = (data, basedOn) => {
    let result = [...new Map(data.map((item) => [item[basedOn], item])).values()];
    return result;
  }

  renderTblRow = (details, index) => {
    let { fromBillMedication, is_From_IpNotes } = this.props;
    let states = this.state;
    let dateTitle = `${t('Date')} & ${t('Time')}`;
    let brandTitle = `${t('BrandName')} & ${t("GenericName")}`;
    let medicTypTitle = `${t('Medication')} ${t('Type')}`;
    const checkUserAccess = this.props.is_From_IpNotes ? false :
      CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Medication", "SubTab")?.editAccess ? this.state.withOutAppointment?.is_ip : true;
    return (
      <>
        <TableRow key={index} className="eMed_medication_head">
          <TableCell align="center" sx={{ flex: 0.2 }}> {details.created_date} </TableCell>
          <TableCell sx={{ flex: 0.2 }} align="left">{t("BillNo") + ": "}{details.bill_no}</TableCell>
          <TableCell sx={{ flex: 0.2 }} align="left">{t("NoOfDrugs") + ": "}{details.number_of_drugs}</TableCell>
          <TableCell sx={{ flex: 0.2 }} align="left">{t("ReceiveDrug") + ": "}{details.received_drugs}</TableCell>
          <TableCell sx={{ flex: 0.2 }} align="center">
            <Stack direction="row" justifyContent="center" alignItems="center" spacing={3}>
              {(details["is_transmit"] || fromBillMedication) ? null :
                <Tooltip title={t("Transmit")} placement='top' arrow>
                  <IconButton disabled={checkUserAccess} size="small" onClick={() => this.handleMedicTransmit(details["medication_summary_id"])}> <img className="eMed_medication_Img" src={this.state.withOutAppointment?.is_ip ? ImagePaths.TransmitOff.default : ImagePaths.medicationTransmitOn.default} alt="transmit" /></IconButton>
                </Tooltip>}
              <div style={{ display: (fromBillMedication || is_From_IpNotes) ? "none" : "block" }}>
                <Tooltip title={t("More")} placement='top' arrow><IconButton size="small" disabled={this.state.withOutAppointment?.is_ip} onClick={(event) => { this.setState({ anchorEl: event.currentTarget, selectedRow: details.index, isSelected: true }) }}><MoreVertIcon /></IconButton></Tooltip>
                {(this.state.isSelected && this.state.selectedRow === details.index) ?
                  <Menu
                    anchorEl={this.state.anchorEl}
                    open={Boolean(this.state.anchorEl)}
                    onClose={(e) => {
                      this.setState({
                        anchorEl: null
                      })
                    }}
                    PaperProps={{
                      style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: '16ch',
                        marginLeft: "-7vw"
                      },
                    }}
                  >
                    {multi_option.map((option) => (
                      <MenuItem key={option} disabled={details["bill_no"] === null} onClick={() => { this.setState({ anchorEl: null, selectedOption: option.value, selectedDetails: details, newSelectedDetails: JSON.stringify(details) }) }}>{t(option.label)}</MenuItem>))}
                  </Menu>
                  : null}
              </div>
              <Tooltip title={t("Details")} placement='top' arrow>
                <IconButton size="small" disabled={this.state.withOutAppointment?.is_ip} onClick={() => this.setState({ selectedIndex: this.state.selectedIndex === index ? null : index }, () => this._getIpMedicationDetails())}>
                  <img className="eMed_Medication_arrowImg" src={states["selectedIndex"] === index ? ImagePaths.upArrow.default : ImagePaths.downArrow.default} alt="Arrow" />
                </IconButton>
              </Tooltip>
            </Stack>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={5}>
            <Collapse in={this.state.selectedIndex === index} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }} className='eMed_Medication_tableDiv'>
                <Table stickyHeader size='small'>
                  <TableHead className="eMed_medication_head" sx={{ height: "6vh" }}>
                    <TableRow>
                      <TableCell id="eMed_Medication_tableTxt" sx={{ flex: 0.11 }} align="center">{dateTitle.length > 10 ? <Tooltip placement="top" title={dateTitle} arrow>
                        <div>{dateTitle.slice(0, 8) + "..."}</div></Tooltip> : dateTitle}</TableCell>
                      <TableCell id="eMed_Medication_tableTxt" sx={{ flex: 0.21 }} align='left'>{brandTitle.length > 12 ? <Tooltip placement="top" title={brandTitle} arrow>
                        <div>{brandTitle.slice(0, 10) + "..."}</div></Tooltip> : brandTitle}</TableCell>
                      <TableCell id="eMed_Medication_tableTxt" sx={{ flex: 0.11 }} align='left'>{`${t('Route')}`}</TableCell>
                      <TableCell id="eMed_Medication_tableTxt" sx={{ flex: 0.11 }} align='left'>{medicTypTitle.length > 10 ? <Tooltip placement="top" title={medicTypTitle} arrow>
                        <div>{medicTypTitle.slice(0, 8) + "..."}</div></Tooltip> : medicTypTitle}</TableCell>
                      <TableCell id="eMed_Medication_tableTxt" sx={{ flex: 0.12 }} align='left'>{`${t('Duration')}`}</TableCell>
                      <TableCell id="eMed_Medication_tableTxt" sx={{ flex: 0.12 }} align='left'>{`${t('MAEN')}`}</TableCell>
                      <TableCell id="eMed_Medication_tableTxt" sx={{ flex: 0.12 }} align='left'>{`${t('Usage')}`}</TableCell>
                      {(details.bill_no || fromBillMedication) ? null : <TableCell id="eMed_Medication_tableTxt" sx={{ flex: 0.10 }} align="center">{`${t('Action')}`}</TableCell>}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {details.line_items.map((dataRow) => {
                      //generic name;
                      let generic_name = `${dataRow.generic_name ? dataRow.generic_name : "-"} | ${dataRow.drug_strength ? dataRow.drug_strength : "-"}`;
                      //medication type;
                      let medicationTyp = (dataRow["tapper"] && dataRow["tapper"].length > 0) ? "Tapper" : "Regular";
                      // duration;
                      let tapperDuration = dataRow["tapper"].length > 0 ? this.getTapperList(dataRow["tapper"], "duration") : [];
                      let duration = tapperDuration.length > 0 ? this._getDetails(tapperDuration, "duration") : "-";
                      let durationTyp = dataRow["tapper"].length === 0 ? `${dataRow.duration ? dataRow.duration : "-"} ${dataRow.duration_type ? dataRow.duration_type : "-"}` : `${duration ? duration : "-"}`;
                      // MAEN;
                      let tapperMaen = dataRow["tapper"].length > 0 ? this.getTapperList(dataRow["tapper"], "no_of_dosage") : [];
                      let tapperMorning = tapperMaen.length > 0 ? this._getDetails(tapperMaen, "no_of_dosage") : "-";
                      let maen = dataRow["tapper"].length === 0 ? `${dataRow.morning ? dataRow.morning : 0}-${dataRow.afternoon ? dataRow.afternoon : 0}-${dataRow.evening ? dataRow.evening : 0}-${dataRow.night ? dataRow.night : 0}` : `${tapperMorning ? tapperMorning : "-"}`;
                      // Usage;
                      let tapperInstru = dataRow["tapper"].length > 0 ? this.getTapperList(dataRow["tapper"], "frequency") : [];
                      let tapperFreq = tapperInstru.length > 0 ? this._getDetails(tapperInstru, "frequency") : "-";
                      let instructions = dataRow["tapper"].length === 0 ? `${dataRow.instructions ? dataRow.instructions : "-"}` : `${tapperFreq ? tapperFreq : "-"}`;
                      return (
                        <TableRow key={dataRow.created_date} className="eMed_medication_head">
                          <TableCell align="center" sx={{ flex: 0.11 }}> {dataRow.created_date} </TableCell>
                          <TableCell align='left' sx={{ flex: 0.21 }}>
                            <Stack direction={"column"}>
                              <Typography sx={{ color: dataRow["schedule"] ? Colors.BillInProcessTxt : null, fontWeight: 600 }}>{dataRow.brand_name.length > 15 ? <Tooltip placement="top" title={dataRow.brand_name}><Typography sx={{ color: dataRow["schedule"] !== null ? Colors.BillInProcessTxt : null, fontWeight: 600 }}>{dataRow.brand_name.slice(0, 12) + "..."}</Typography></Tooltip> : dataRow.brand_name ? dataRow.brand_name : "-"}</Typography>
                              <div>{generic_name.length > 15 ? <Tooltip placement="top" title={generic_name} arrow><div>{generic_name.slice(0, 12) + "..."}</div></Tooltip> : generic_name ? generic_name : "-"}</div>
                            </Stack>
                          </TableCell>
                          <TableCell align='left' sx={{ flex: 0.11 }}>{<div>{dataRow.route.length > 10 ? <Tooltip placement="top" title={dataRow.route} arrow><div>{dataRow.route.slice(0, 8) + "..."}</div></Tooltip> : dataRow.route ? dataRow.route : "-"}</div>}</TableCell>
                          <TableCell align='left' sx={{ flex: 0.11 }}>{<div>{medicationTyp.length > 10 ? <Tooltip placement="top" title={medicationTyp} arrow><div>{medicationTyp.slice(0, 8) + "..."}</div></Tooltip> : medicationTyp ? medicationTyp : "-"}</div>}</TableCell>
                          <TableCell align='left' sx={{ flex: 0.12 }}>{<div>{durationTyp?.length > 10 ? <Tooltip placement="top" title={durationTyp} arrow><div>{durationTyp.slice(0, 8) + "..."}</div></Tooltip> : durationTyp ? durationTyp : "-"}</div>}</TableCell>
                          <TableCell align='left' sx={{ flex: 0.12 }}>{<div>{maen?.length > 10 ? <Tooltip placement="top" title={maen} arrow><div>{maen.slice(0, 8) + "..."}</div></Tooltip> : maen ? maen : "-"}</div>}</TableCell>
                          <TableCell align='left' sx={{ flex: 0.12 }}>{<div>{instructions?.length > 10 ? <Tooltip placement="top" title={instructions} arrow><div>{instructions.slice(0, 8) + "..."}</div></Tooltip> : instructions ? instructions : "-"}</div>}</TableCell>
                          {(details["bill_no"] || fromBillMedication) ? null : <TableCell sx={{ flex: 0.10 }} align="center">
                            <Stack direction={"row"} justifyContent="space-between" alignItems="center">
                              <CommonEditButton disable={this.state.withOutAppointment?.is_ip} size="1.5vw" onClick={this.handleEdit.bind(this, dataRow, details["pharmacy_name"], details["pharmacy_id"])} />
                              <CommonDeleteButton disable={this.state.withOutAppointment?.is_ip} size="1.5vw" onClick={this.handleDelete.bind(this, dataRow)} />
                            </Stack>
                          </TableCell>}
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    );
  }

  handleMedicTransmit = (id) => {
    // if (id) {
    let tranmitIds = [];
    this.state.transmitData?.forEach(element => tranmitIds?.push(element?.id))
    let data = {
      "id": tranmitIds
    }
    // let data = {
    //   "medication_summary_id": id
    // }
    try {
      if (tranmitIds?.length === 0) {
        this.errorMessage('Please Select atleast one line items')
      } else {
        RestAPIService.patch(data, Serviceurls.IP_MEDICATION_GET)
          .then(response => {
            if (response.data.status === "success") {
              this.responseSuccessErrorMessage(response.data.message, true);
              this._getIpMedicationDetails();
            }
          })
          .catch(error => {
            if (error?.response?.data?.status === "fail") {
              this.responseSuccessErrorMessage(error.response.data.message, false);
            }
          });
      }
    } catch (e) {
      this.responseSuccessErrorMessage(e.message, false);
    }
    // }
  }


  handleRecallSubmit = () => {
    const { recallSelectedIds, recallReason, recallMedicationList } = this.state;

    if (recallSelectedIds.length === 0) {
      this.errorMessage('Please select at least one medication to recall');
      return;
    }

    if (!recallReason.trim()) {
      this.errorMessage('Please enter reason for recall');
      return;
    }

    // Get the selected medications from recallMedicationList
    const selectedMedications = recallMedicationList.filter(item =>
      recallSelectedIds.includes(item.sno)
    );
 
    console.log('Recalling medications:', selectedMedications);
    console.log('Reason:', recallReason);

    // Here you would typically make an API call to recall the medications
    try {
      const data = {
        id: selectedMedications.map(med => med.id),
        recalled_reason: recallReason,
      };

      RestAPIService.create(data, Serviceurls.MEDICATION_RECALL_LIST)
        .then(response => {
          if (response.data.status === "success") {
            this.successMessage(`${selectedMedications.length} Medications recalled successfully`);
            this._getIpMedicationDetails(); // Refresh the list
            // Close dialog and reset state
            this.setState({
              showRecallDialog: false,
              recallSelectedIds: [],
              recallReason: '',
              recallMedicationList: [],
              recallIsAllSelected: false
            });
          }
        })
        .catch(error => {
          this.errorMessage(error.response?.data?.message || 'Recall failed');
        });
    } catch (error) {
      this.errorMessage('Recall operation failed');
    }
  };

  handleRecallToggle = (sno) => {
    this.setState(prevState => {
      const selectedIds = prevState.recallSelectedIds.includes(sno)
        ? prevState.recallSelectedIds.filter(id => id !== sno)
        : [...prevState.recallSelectedIds, sno];

      const isAllSelected = selectedIds.length === prevState.recallMedicationList.length;

      return {
        recallSelectedIds: selectedIds,
        recallIsAllSelected: isAllSelected
      };
    });
  };

  handleRecallSelectAll = () => {
    this.setState(prevState => {
      const allIds = prevState.recallMedicationList.map(item => item.sno);
      const newSelectedIds = prevState.recallIsAllSelected ? [] : allIds;

      return {
        recallSelectedIds: newSelectedIds,
        recallIsAllSelected: !prevState.recallIsAllSelected
      };
    });
  };

  handleRecallChange = (e) => {
    this.setState({ recallReason: e.target.value });
};

  recallDrugList = () => {
    const { newMedicationRequestList } = this.state;

    // Transform medication data for the table - only show non-transmitted, non-external drugs
    const medicationList = newMedicationRequestList
      .filter(item => item.medication_status === 'Transmitted')
      .map((item, index) => ({
        id: item.id || index,
        sno: item.sno || index + 1,
        date: item.created_date || '-',
        drug: `${item.brand_name || '-'}\n${item.generic_name || ''} ${item.drug_strength || ''}`.trim(),
        status: item.medication_status || 'Transmitted',
        originalData: item
      }));

    // If dialog is opening and we have medications, initialize state
    if (this.state.showRecallDialog && this.state.recallMedicationList.length === 0 && medicationList.length > 0) {
      this.setState({
        recallMedicationList: medicationList,
        recallSelectedIds: [],
        recallIsAllSelected: false,
        recallReason: ''
      });
    }

    // If no medications available for recall
    if (medicationList.length === 0 && this.state.showRecallDialog) {
      this.errorMessage('No transmitted medications available for recalll');
      this.setState({ showRecallDialog: false });
      return null;
    }

    // Use recallMedicationList for rendering instead of medicationList
    const { recallMedicationList, recallSelectedIds, recallIsAllSelected } = this.state;

    return (
      <Dialog
        open={this.state.showRecallDialog}
        onClose={() => this.setState({
          showRecallDialog: false,
          recallMedicationList: [],
          recallSelectedIds: [],
          recallReason: '',
          recallIsAllSelected: false
        })}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: '8px',
            maxHeight: '80vh'
          }
        }}
      >
        <DialogTitle sx={{
          backgroundColor: '#f5f5f5',
          borderBottom: '1px solid #e0e0e0',
          fontSize: '1.1rem',
          fontWeight: 'bold',
          padding: '16px 24px'
        }}>
          Recall Medication
        </DialogTitle>

        <DialogContent dividers sx={{ padding: '16px', overflowY: 'hidden' }}>
          {/* Medication Table */}
          <TableContainer
            sx={{
              border: '1px solid #ccc',
              borderRadius: '4px',
              maxHeight: 300,
              marginBottom: 2,
            }}
          >
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                  <TableCell padding="checkbox" sx={{ width: '60px' }}>
                    <Checkbox
                      checked={recallIsAllSelected && recallMedicationList.length > 0}
                      onChange={this.handleRecallSelectAll}
                      indeterminate={
                        recallSelectedIds.length > 0 &&
                        recallSelectedIds.length < recallMedicationList.length
                      }
                    />
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '0.875rem' }}>Date & Time</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '0.875rem', width: '260vw' }}>Drug Details</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '0.875rem', width: '10vw' }}>Status</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {recallMedicationList.map((row) => (
                  <TableRow
                    key={row.sno}
                    sx={{
                      '&:hover': { backgroundColor: '#fafafa' },
                      backgroundColor: recallSelectedIds.includes(row.sno) ? '#e3f2fd' : 'inherit'
                    }}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={recallSelectedIds.includes(row.sno)}
                        onChange={() => this.handleRecallToggle(row.sno)}
                      />
                    </TableCell>
                    <TableCell sx={{ fontSize: '0.8rem', width: '71vw' }}>
                        {row.date}
                    </TableCell>
                    <TableCell>
                      <div style={{
                        whiteSpace: 'pre-wrap',
                        fontSize: '0.8rem',
                        lineHeight: '1.2'
                      }}>
                        {row.drug}
                      </div>
                    </TableCell>
                    <TableCell sx={{ fontSize: '0.8rem', width: '10vw' }}>
                      {row.status}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Reason for Recall Text Field */}
          <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1, fontSize: '0.9rem' }}>
            Reason for Recall*
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            value={this.state.recallReason}
            // onChange={(e) => this.setState({ recallReason: e.target.value })}
            onChange={this.handleRecallChange}
            variant="outlined"
            placeholder="Enter reason for medication recall..."
            inputProps={{ maxLength: 350 }}
            sx={{
              '& .MuiOutlinedInput-root': {
                fontSize: '0.875rem'
              }
            }}
          />
        </DialogContent>

        <DialogActions sx={{ padding: '16px', gap: 1 }}>
          <Button
            onClick={() => this.setState({
              showRecallDialog: false,
              recallSelectedIds: [],
              recallReason: '',
              recallMedicationList: [],
              recallIsAllSelected: false
            })}
            size="small"
            variant="outlined"
            sx={{
              textTransform: "capitalize"
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={this.handleRecallSubmit}
            size="small"
            variant="contained"
            disabled={recallSelectedIds.length === 0}
            sx={{
             textTransform: "capitalize"
            }}
          >
            Recall
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
 

  MedicPopUpClose = () => {
    this.state.medicationDetails.forEach((item, i) => {
      item["line_items"] = item["line_items"]?.map((list, index) => ({ ...list, "return_quantity": null }))
    })
    this.setState({
      selectedOption: "",
      selectedDetails: [],
      newSelectedDetails: [],
      medicationDetails: this.state.medicationDetails
    })
  }

  MedicPopUpClear = () => {
    this.setState({
      selectedDetails: JSON.parse(this.state.newSelectedDetails)
    })
  }

  _showReturnDetails = () => {
    let { selectedDetails } = this.state;
    let date_time = `${selectedDetails.bill_date ? selectedDetails.bill_date : "-"} | ${selectedDetails.invoice_date ? selectedDetails.invoice_date : "-"}`
    return (
      <Stack sx={{ width: "100%" }} direction="column" alignItems="flex-start" justifyContent="center" spacing={2}>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={5} m={1}>
          <Typography>{`${t("Pharmacy")} : `}<span style={{ fontWeight: 600 }}>{selectedDetails.pharmacy_name ? selectedDetails.pharmacy_name : "-"}</span></Typography>
          <Typography>{`${t("BillNo")} : ${selectedDetails.bill_no ? selectedDetails.bill_no : "-"}`}</Typography>
          <Typography>{`${t("BillDate")} : ${date_time ? date_time : "-"}`}</Typography>
        </Stack>
        <TableContainer id="eMed_medication_rtnTbl" component={Paper} elevation={0} sx={{ backgroundColor: "#FFFF" }}>
          <Table>
            <TableHead stickyHeader size='small' sx={{ height: "4vh", backgroundColor: Colors.DataTblHeaderbg }}>
              <TableRow className="eMed_medication_head">
                <TableCell id="eMed_medication_headTxt" sx={{ flex: 0.16 }}>{`${t('CreatedBy')}`}</TableCell>
                <TableCell id="eMed_medication_headTxt" sx={{ flex: 0.18 }}>{`${t('BrandName')} ${t('and')} ${t("GenericName")}`}</TableCell>
                <TableCell id="eMed_medication_headTxt" sx={{ flex: 0.18 }}>{`${t('Received')}/${t("BilledQuantity")}`}</TableCell>
                <TableCell id="eMed_medication_headTxt" sx={{ flex: 0.16 }}>{`${t('ReturnQuantity')}`}</TableCell>
                <TableCell id="eMed_medication_headTxt" sx={{ flex: 0.16 }}>{`${t('Status')}`}</TableCell>
                <TableCell id="eMed_medication_headTxt" sx={{ flex: 0.16 }}>{`${t('ModifiedBy')}`}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedDetails["line_items"].map((row, index) => {
                let createdBy = `${row.created_by ? row.created_by : "-"} | ${row.created_date ? row.created_date : "-"}`;
                let brand_name = `${row.brand_name ? row.brand_name : "-"} | ${row.generic_name ? row.generic_name : "-"}`;
                let modifiedBy = `${row.modified_by ? row.modified_by : "-"} | ${row.modified_date ? row.modified_date : "-"}`;
                return (
                  <TableRow key={row.created_date}>
                    <TableCell sx={{ flex: 0.16 }}><div>{createdBy.length > 20 ? <Tooltip placement="top" title={createdBy} arrow><div>{createdBy.slice(0, 17) + "..."}</div></Tooltip> : createdBy ? createdBy : "-"}</div></TableCell>
                    <TableCell sx={{ flex: 0.18 }}><Typography sx={{ color: row["schedule"] ? Colors.BillInProcessTxt : null, fontWeight: 600 }}>{brand_name.length > 20 ? <Tooltip placement="top" title={brand_name} arrow>
                      <Typography sx={{ color: row["schedule"] ? Colors.BillInProcessTxt : null, fontWeight: 600 }}>{brand_name.slice(0, 17) + "..."}</Typography></Tooltip> : brand_name ? brand_name : "-"}</Typography>
                    </TableCell>
                    <TableCell sx={{ flex: 0.18 }}><Typography>{`${row.received_quantity ? row.received_quantity : ""} / ${row.quantity ? row.quantity : ""}`}</Typography></TableCell>
                    <TableCell sx={{ flex: 0.16, }}>
                      <Box sx={{ display: 'flex' }}>
                        <TextField
                          name="return_quantity"
                          value={row["return_quantity"] ? row["return_quantity"] : ""}
                          size="small"
                          autoComplete="off"
                          disabled={!selectedDetails["line_items"][index]["drug_ms_id"]}
                          onChange={(e) => {
                            let value = e.target.value;
                            let isValid = CommonValidation.numberOnly(value);
                            if (value === "" || (isValid && value > 0 && parseInt(value) <= parseInt(row.received_quantity))) {
                              selectedDetails["line_items"][index]["return_quantity"] = value;
                              this.setState({
                                selectedDetails
                              })
                            }
                          }}
                          sx={{ width: "5vw" }}
                        />
                        <TextField
                          name="return_quantity"
                          value={row["already_return_quantity"] ? row["already_return_quantity"] : ""}
                          size="small"
                          autoComplete="off"
                          disabled={true}
                          sx={{ width: "5vw" }}
                        />
                      </Box>
                    </TableCell>
                    <TableCell sx={{ flex: 0.16 }}>{<div>{row.status.length > 20 ? <Tooltip placement="top" title={row.status} arrow><div>{row.status.slice(0, 18) + "..."}</div></Tooltip> : row.status ? row.status : "-"}</div>}</TableCell>
                    <TableCell sx={{ flex: 0.16 }}>{<div>{modifiedBy.length > 20 ? <Tooltip placement="top" title={modifiedBy} arrow><div>{modifiedBy.slice(0, 18) + "..."}</div></Tooltip> : modifiedBy ? modifiedBy : "-"}</div>}</TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    )
  }

  handleMedicSave = () => {
    const { t } = this.props;
    let { selectedDetails } = this.state;
    // let isAvl = true;
    // let Message = "";
    // let isReturnAvl = selectedDetails["line_items"].every(item => (item["return_quantity"] === 0 || item["return_quantity"] === null));
    // if (isReturnAvl) { isAvl = false; Message = `${t("Enter")} ${t("ReturnQuantity")}` }
    // if (isAvl) {
    //   // api call
    //   let returnList = selectedDetails["line_items"].filter(item => item["return_quantity"] !== 0 || item["return_quantity"] !== null);
    //   let data = {
    //     "is_return": true,
    //     "return_detail": []
    //   }
    //   returnList.forEach(item => {
    //     let temp = {
    //       "line_item_id": item["line_item_id"],
    //       "return_quantity": +item["return_quantity"]
    //     }
    //     data["return_detail"].push(temp)
    //   });
    try {
      let returnData = [];
      this.state.returnData?.forEach(element => {
        returnData?.push({ line_item_id: element?.line_item_id ? element?.line_item_id : element?.id, return_quantity: +element?.return_qty, batch_no: element?.batch_no })
      })
      let data = {
        is_return: true,
        return_detail: returnData
      }
      if (returnData?.length === 0) {
        this.errorMessage('Please Select atleast one line item to return')
      } else {
        RestAPIService.updateWithOutId(data, Serviceurls.IP_MEDICATION_GET)
          .then(response => {
            if (response.data.status === "success") {
              this.MedicPopUpClose();
              this.responseSuccessErrorMessage(response.data.message, true);
              this._getIpMedicationDetails();
              this.state.newMedicationReturnList?.forEach(element => element.return_qty = '')
              this.setState({ returnData: [], newMedicationReturnList: this.state.newMedicationReturnList })
            }
          })
          .catch(error => {
            if (error?.response?.data?.status === "fail") {
              this.responseSuccessErrorMessage(error.response.data.message, false);
            }
          });
      }
    } catch (e) {
      this.responseSuccessErrorMessage(e.message, false);
    }
    // } else {
    //   this.responseSuccessErrorMessage(Message, false);
    // }
  }

  // left table end

  handleDuration = (statekey, value) => {
    let states = this.state;
    let isValid = false;

    if (!(this.state.isTapper) && (statekey !== "tapperDuration" || statekey !== "tapperDuration_mode")) {
      if (states[statekey] === value) {
        states[statekey] = ""
        this.setState({ states })
      }
      else {
        states[statekey] = value;
        this.setState({ states })
      }
    }

    if (statekey === "tapperDuration") {
      isValid = CommonValidation.numberOnly(value);
      if (value === "" || (isValid && value.length <= 2 && value <= 31)) {
        states["tapperDuration"] = value;
      }
    }
    if (statekey === "tapperDuration_mode") {
      states["tapperDuration_mode"] = value;
    }

    let qty = Math.round(states["morning"]) + Math.round(states["afternoon"]) + Math.round(states["evening"]) + Math.round(states["night"]);
    let duration_mode = this.state.isTapper ? states["tapperDuration_mode"] : states["duration_mode"];
    let duration = this.state.isTapper ? states["tapperDuration"] : states["duration"];

    switch (duration_mode) {
      case "Week(s)":
        states["quantity"] = +(qty ? qty : 1) * +(duration) * 7;
        break;
      case "Month(s)":
        states["quantity"] = +(qty ? qty : 1) * +(duration) * 30;
        break;
      default:
        states["quantity"] = +(qty ? qty : 1) * +(duration) * 1;
    }
    this.setState({
      states
    })
  }

  handleChipClk = (value) => {
    let states = this.state;
    if (value.drug_name) {
      states["mediItem"]["brand_name"] = value?.drug_name;
      states["mediItem"]["drug_ms_id"] = "";
      states["mediItem"]["generic_name"] = "";
      states["mediItem"]["dosage_type"] = "";
      states["mediItem"]["dosage_strength"] = "";
      this.setState({
        states,
        genericList: []
      }, () => {
        this._getBrandDetails(value?.drug_name, value?.generic_name);
      })
    }
  }

  historyPopUpClose = () => {
    this.setState({
      isHistoryClicked: false,
      historyData: []
    })
  }

  _showHistory(historydata) {
    const { t } = this.props;
    const historyColumn = [
      {
        field: 'modified_by_from', headerName: t('ModifiedBy'), sortable: false, hideable: false, width: 200, renderCell: ({ row }) => {
          return (<div>{row?.modified_by_from?.length > 20 ? <Tooltip placement="top" title={row?.modified_by_from} arrow><div>{row?.modified_by_from.slice(0, 15) + "..."}</div></Tooltip> : row?.modified_by_from ? row?.modified_by_from : "-"}</div>)
        }
      },
      {
        field: 'modified_date', headerAlign: "center", headerName: t('ModifiedDateAndTime'), sortable: false, hideable: false, width: 250, align: "center", renderCell: ({ row }) => {
          return (<Typography>{row?.modified_date ? row?.modified_date : "-"}</Typography>)
        }
      },
      {
        field: 'dosage_type_from', headerName: `${t('Previous')}  ${t('DosageType')}`, width: 250, sortable: false, hideable: false, renderCell: ({ row }) => {
          return (<div>{row?.dosage_type_from?.length > 20 ? <Tooltip placement="top" title={row?.dosage_type_from} arrow><div>{row?.dosage_type_from.slice(0, 15) + "..."}</div></Tooltip> : row?.dosage_type_from ? row?.dosage_type_from : "-"}</div>)
        }
      },
      {
        field: 'route_from', headerName: `${t('Previous')}  ${t('Route')}`, width: 200, sortable: false, hideable: false, renderCell: ({ row }) => {
          return (<div>{row?.route_from?.length > 20 ? <Tooltip placement="top" title={row?.route_from} arrow><div>{row?.route_from.slice(0, 15) + "..."}</div></Tooltip> : row?.route_from ? row?.route_from : "-"}</div>)
        }
      },
      {
        field: 'instructions_from', headerName: `${t('Previous')}  ${t('Usage')}`, width: 200, sortable: false, hideable: false, renderCell: ({ row }) => {
          return (<div>{row?.instructions_from?.length > 20 ? <Tooltip placement="top" title={row?.instructions_from} arrow><div>{row?.instructions_from.slice(0, 15) + "..."}</div></Tooltip> : row?.instructions_from ? row?.instructions_from : "-"}</div>)
        }
      },
      {
        field: 'duration_from', headerAlign: "center", headerName: `${t('Previous')}  ${t('Duration')}`, width: 200, align: "center", sortable: false, hideable: false, renderCell: ({ row }) => {
          return (<div>{row?.duration_from?.length > 20 ? <Tooltip placement="top" title={row?.duration_from} arrow><div>{row?.duration_from.slice(0, 15) + "..."}</div></Tooltip> : row?.duration_from ? row?.duration_from : "-"}</div>)
        }
      },
      {
        field: 'previous_maen', headerName: `${t('Previous')}  ${t('MAEN')}`, width: 200, sortable: false, hideable: false, renderCell: ({ row }) => {
          let Previous_maen = `${row.morning_from ? row.morning_from : 0}-${row.afternoon_from ? row.afternoon_from : 0}-${row.evening_from ? row.evening_from : 0}-${row.night_from ? row.night_from : 0}`
          return (<div>{Previous_maen?.length > 20 ? <Tooltip placement="top" title={Previous_maen} arrow><div>{Previous_maen.slice(0, 15) + "..."}</div></Tooltip> : Previous_maen !== "0-0-0-0" ? Previous_maen : "-"}</div>)
        }
      }];
    return (
      <Box id="eMed_ipsrvConfig_accTbl">
        <DataGrid
          rows={historydata ? historydata : []}
          columns={historyColumn}
          getRowId={(row) => row.modified_date}
          disableColumnMenu
          hideFooter
          components={{
            NoRowsOverlay: () => {
              return (
                <Stack direction="row" justifyContent="center" alignItems="center" sx={{ height: "40vh" }}>
                  {t("NoRecordsFound")}
                </Stack>
              )
            }
          }}
          headerHeight={40}
        />
      </Box>
    )
  }

  onChangeHandler = (statekey, value) => {
    let states = this.state;
    let { tapperItem } = this.state;
    let valueTrimed = value.trimStart();
    let isValid;
    switch (statekey) {
      case "tapperUnit_typ":
        states["tapperUnit_typ"] = valueTrimed;
        break;
      case "tapperReduced_typ":
        states["tapperReduced_typ"] = valueTrimed;
        break;
      default:
        isValid = CommonValidation.NumberWithDot(valueTrimed);
        if (valueTrimed === "" || isValid) {
          tapperItem[statekey] = valueTrimed;
        }
        break;
    }
    this.setState({
      tapperItem,
      states
    })
  }

  handleEdit = (value, pharmacy_name, pharmacy_id) => {
    let states = this.state;
    if (value.brand_name) {
      states["mediItem"]["line_item_id"] = value["line_item_id"];
      // Add nurse data mapping
      if (value.nurse_profile_id) {
        const selectedNurse = this.state.nurseList.find(
          nurse => nurse.nurse_id === value.nurse_profile_id
        );
        states["selectedNurse"] = selectedNurse || null;
        states["nurseName"] = selectedNurse?.nurse_name || "";
      } else {
        states["selectedNurse"] = null;
        states["nurseName"] = "";
      }
      if (value.drug_ms_id) {
        states["ExternalDrug"] = false;
        states["mediItem"]["brand_name"] = value?.brand_name;
        states["mediItem"]["drug_ms_id"] = value?.drug_ms_id;
        states["mediItem"]["generic_name"] = value?.generic_name;
        states["mediItem"]["dosage_type"] = value?.dosag_type;
        states["mediItem"]["dosage_strength"] = value?.drug_strength;
        states["mediItem"]["Selected_days"] = value.Selected_days ? value.Selected_days?.map(item => this.convertNumberToDay(item)) : [];
        if (value["route"] && value["route"].trim() !== "") {
          if (IP_routeList.find((item) => (item?.value === value["route"]))) {
            states["mediItem"]["route"] = value["route"];
          } else {
            states["mediItem"]["route"] = "Others";
            states["mediRouteOther"] = value["route"];
          }
        } else {
          states["mediItem"]["route"] = "";
        }
      } else {
        states["ExternalDrug"] = true;
        states["externalBrandName"] = value.brand_name;
        states["externalGenName"] = value.generic_name;
        states["externalDosageType"] = value.dosag_type;
        states["externalDosStrength"] = value.drug_strength;
        states["externalRoute"] = value.route;
        states["fo_external_drug_id"] = value.fo_external_drug_id;
        if (value["route"] && value["route"].trim() !== "") {
          if (IP_routeList.find((item) => (item?.value === value["route"]))) {
            states["externalRoute"] = value["route"];
          } else {
            states["externalRoute"] = "Others";
            states["externalRouteOther"] = value["route"];
          }
        } else {
          states["mediItem"]["route"] = "";
        }
      }
      states["duration"] = value.duration ? value.duration : null;
      states["morning"] = value.morning;
      states["afternoon"] = value.afternoon;
      states["evening"] = value.evening;
      states["night"] = value.night;
      states["duration_mode"] = value.duration_type;
      states["quantity"] = value.quantity;
      states["instruction"] = value.instructions;
      states["pharma_id"] = pharmacy_id;
      states["pharma_name"] = pharmacy_name;
      states["medication_id"] = value.id;
      states["isEdit"] = true;
      states["tapperDetails"] = value.tapper;
      states["Selected_days"] = value.selective_days ? value.selective_days?.map(item => this.convertNumberToDay(item)) : [];

      const instructionValue = value.instructions;

      const allUsageOptions = this.getUsageOptions();
      const selectedUsage = allUsageOptions.find(item =>
        item.label === instructionValue || this.instructions(item.label) === instructionValue
      );
      this.setState({
        states,
        isTapper: Object.values(value.tapper).length > 0,
        selectedUsage: selectedUsage,
        genericList: []
      }, () => {
        if (states.ExternalDrug) {
          this.getExternalDrugSearchList(value?.brand_name, "")
        }
        this._getBrandDetails(value?.brand_name, value?.generic_name);
      })
    }
  }

  handleDelete = (value) => {
    if (!(this.state.isEdit)) {
      this.setState({
        deletedPopup: true,
        brand_name: value?.brand_name,
        medication_id: value?.line_item_id
      })
    }
  }

  handleClear = () => {
    this.setState({
      // pharma_name: "",
      // pharma_id: null,
      mediItem: {},
      tapperItem: {},
      open: false,
      duration_mode: "Day(s)",
      duration: null,
      isTapper: false,
      instruction: "",
      tapperDuration_mode: "Day(s)",
      tapperDuration: "",
      tapperStartDate: today,
      tapperUnit_typ: "",
      tapperReduced_typ: "mg",
      tapperDetails: [],
      selectedEditIndex: null,
      tapperFrequency: "",
      focusError: "",
      isEdit: false,
      morning: 0,
      afternoon: 0,
      evening: 0,
      night: 0,
      quantity: null,
      Selected_days: [],
      ExternalDrug: "",
      externalBrandName: "",
      externalGenName: "",
      externalDosageType: "",
      externalDosStrength: "",
      externalRoute: "",
      ExternalDrugList: [],
      dupExternalDrugList: [],
      genericSuggList: [],
      fo_external_drug_id: null,
      selectedNurse: null,
      nurseName: "",
      prescriptionUsage: [],
      selectedUsage: null,
      openAddNew: false,
      prescUsage: null,
      postUsageLoad: false,
    }, () => {
      if (this.state.pharma_id) {
        this.getFrequentDrugInPharma()
        this._getIpMedicationDetails();
      }
      if (this.state.nurseList?.length && localGetItem("NurseId") && !this.state?.selectedNurse?.nurse_id) {
        let nurseId = JSON.parse(localGetItem("NurseId"))
        let nurseData = this.state.nurseList.find((item) => item.nurse_id === nurseId)
        this.setState({
          selectedNurse: nurseData,
          nurseName: nurseData,
        })
      }
      // this._getPharmaList()
    })
  }

  clearOnChange = () => {
    try {
      this.setState({
        mediItem: {},
        tapperItem: {},
        open: false,
        duration_mode: "Day(s)",
        duration: null,
        isTapper: false,
        instruction: "",
        tapperDuration_mode: "Day(s)",
        tapperDuration: "",
        tapperStartDate: today,
        tapperUnit_typ: "",
        tapperReduced_typ: "mg",
        tapperDetails: [],
        selectedEditIndex: null,
        tapperFrequency: "",
        focusError: "",
        isEdit: false,
        morning: 0,
        afternoon: 0,
        evening: 0,
        night: 0,
        quantity: null,
        // Selected_days: [],
        // ExternalDrug: "",
        externalBrandName: "",
        externalGenName: "",
        externalDosageType: "",
        externalDosStrength: "",
        externalRoute: "",
        ExternalDrugList: [],
        dupExternalDrugList: [],
        genericSuggList: [],
        fo_external_drug_id: null,
        selectedNurse: null,  
        nurseName: "",  
      }, () => {
        if (this.state.nurseList?.length && localGetItem("NurseId")) {
          let nurseId = JSON.parse(localGetItem("NurseId"))
          let nurseData = this.state.nurseList.find((item) => item.nurse_id === nurseId)
          this.setState({
            selectedNurse: nurseData,
            nurseName: nurseData,
          })
        }
      })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  handleAdd = (data = []) => {
    const { t } = this.props;
    let UserData = JSON.parse(localGetItem("loggedInUserInfo"));
    let states = this.state;
    let { mediItem } = this.state;
    let isAvl = true;
    let Message = "";
    if (data?.length === 0) {
      let MAEN = (states["morning"] == 0 && states["afternoon"] == 0 && states["evening"] == 0 && states["night"] == 0)
      if (!states["pharma_name"] && !mediItem["drug_ms"] && MAEN && !states["duration"] && !states["instruction"] && !states["nurseName"]) { isAvl = false; Message = t("Fillmandatory") }
      else if (!states["pharma_name"]) { isAvl = false; Message = t("SelectPharmacy") }
      else if (!mediItem["drug_ms_id"] && !states.ExternalDrug) { isAvl = false; Message = `${t("Enter")} ${t("BrandName")}` }
      // else if (!mediItem["route"]) { isAvl = false; Message = `${t("Enter")} ${t("Route")}` }
      // else if (states["isTapper"] === false && MAEN) { isAvl = false; Message = `${t("Enter")} ${t("MAEN")}` }
      // else if (states["isTapper"] === false && !states["duration"]) { isAvl = false; Message = `${t("Enter")} ${t("Duration")}` }
      // else if (states["isTapper"] === false && !states["instruction"]) { isAvl = false; Message = `${t("Select")} ${t("Usage")}` }
      else if (states["isTapper"] === false && !states["nurseName"]) { isAvl = false; Message = `${t("Select")} ${t("Nurse")}` }
      else if (states["isTapper"] === false && !disallowed.has(states["instruction"]) && MAEN) {isAvl = false; Message = `${t("Enter")} ${t("MAEN Dosage Quantity")}` }
      else if (states["isTapper"] === false && !disallowed.has(states["instruction"]) && !states["duration"]) {  isAvl = false; Message = `${t("Enter")} ${t("Duration")}` }
      else if (states["isTapper"]) {
        if (states["tapperDetails"].length === 0) { isAvl = false; Message = `${t("Enter")} ${t("TapperDetails")}` }
      }
      else if (states.ExternalDrug && (!states["externalBrandName"] || !states["externalGenName"] || !states["externalDosageType"] || !states["externalDosStrength"] || (!states["externalRoute"] || (!states["nurseName"]) || (states["externalRoute"] === "Others" && !states["externalRouteOther"])))) {
        if (!states["externalBrandName"]) { isAvl = false; Message = `${t("Enter")} ${t("Brand Name")}` }
        else if (!states["externalGenName"]) { isAvl = false; Message = `${t("Enter")} ${t("Generic Name")}` }
        else if (!states["externalDosageType"]) { isAvl = false; Message = `${t("Select")} ${t("Dosage Type")}` }
        else if (!states["externalDosStrength"]) { isAvl = false; Message = `${t("Enter")} ${t("Dosage Strength")}` }
        // else if (!states["externalRoute"]) { isAvl = false; Message = `${t("Select")} ${t("Route")}` }
        // else if (states["externalRoute"] === "Others" && !states["externalRouteOther"]) { isAvl = false; Message = `${t("Select")} ${t("Route")}` }
        else if (!states["nurseName"]) { isAvl = false; Message = `${t("Select")} ${t("Nurse")}` }
      }
    }
    if (isAvl) {
      // api call
      const nurseProfileId = states.selectedNurse?.nurse_id || null;
      const nurseName = states.selectedNurse?.nurse_name || "";
      let datas = {}
      let method = ""
      if (mediItem["line_item_id"] && states["isEdit"]) {
        method = "updateWithOutId"
        datas = {
          "line_item_id": mediItem["line_item_id"] ? mediItem["line_item_id"] : null,
          "drug_ms_id": mediItem["drug_ms_id"] ? mediItem["drug_ms_id"] : null,
          "morning": states["morning"] && (!states["isTapper"]) ? +(states["morning"]) : 0,
          "afternoon": states["afternoon"] && (!states["isTapper"]) ? +(states["afternoon"]) : 0,
          "evening": states["evening"] && (!states["isTapper"]) ? +(states["evening"]) : 0,
          "night": states["night"] && (!states["isTapper"]) ? +(states["night"]) : 0,
          "route": states?.ExternalDrug ? states["externalRoute"] ? (states["externalRoute"] === "Others" ? states["externalRouteOther"] : states["externalRoute"]) : "" : mediItem["route"] ? (mediItem["route"] === "Others" ? states["mediRouteOther"] : mediItem["route"]) : "",
          "duration": states["duration"] && (!states["isTapper"]) ? +(states["duration"]) : 0,
          "duration_type": states["duration_mode"] && (!states["isTapper"]) ? states["duration_mode"] : states["isTapper"] ? "" : "Day(s)",
          "quantity": states["quantity"] ? +(states["quantity"]) : 0,
          "instructions": states["instruction"] && (!states["isTapper"]) ? states["instruction"] : "",
          "tapper": states["tapperDetails"].length > 0 && states["isTapper"] ? states["tapperDetails"] : [],
          "drug_name": states["externalBrandName"] ? states["externalBrandName"] : "",
          "generic_name": states["externalGenName"] ? states["externalGenName"] : "",
          "dosage_type": states["externalDosageType"] ? states["externalDosageType"] : "",
          "dosage_strength": states["externalDosStrength"] ? states["externalDosStrength"] : "",
          "selective_days": states["Selected_days"].length > 0 ? states["Selected_days"].map(item => this.convertDayToNumber(item)) : [],
          'fo_external_drug_id': states['fo_external_drug_id'] ? states['fo_external_drug_id'] : null,
          "nurse_profile_id": states.selectedNurse?.nurse_id || null,
          "nurse_name": nurseName,
        }
      } else {
        method = "create"
        datas = {
          "pharmacy_id": states["pharma_id"] ? states["pharma_id"] : null,
          "ip_admission_id": states["patientData"]["id"] ? states["patientData"]["id"] : null,
          "line_items": data.length > 0 ? data : [{
            "is_tapper": states["isTapper"],
            "drug_ms": mediItem["drug_ms_id"] ? mediItem["drug_ms_id"] : null,
            "morning": states["morning"] && (!states["isTapper"]) ? +(states["morning"]) : 0,
            "afternoon": states["afternoon"] && (!states["isTapper"]) ? +(states["afternoon"]) : 0,
            "evening": states["evening"] && (!states["isTapper"]) ? +(states["evening"]) : 0,
            "night": states["night"] && (!states["isTapper"]) ? +(states["night"]) : 0,
            "route": states?.ExternalDrug ? states["externalRoute"] ? (states["externalRoute"] === "Others" ? states["externalRouteOther"] : states["externalRoute"]) : "" : mediItem["route"] ? (mediItem["route"] === "Others" ? states["mediRouteOther"] : mediItem["route"]) : "",
            "duration": states["duration"] && (!states["isTapper"]) ? +(states["duration"]) : 0,
            "duration_type": states["duration_mode"] && (!states["isTapper"]) ? states["duration_mode"] : states["isTapper"] ? "" : "Day(s)",
            "quantity": states["quantity"] ? +(states["quantity"]) : 0,
            "instructions": states["instruction"] && (!states["isTapper"]) ? states["instruction"] : "",
            "tapper": states["tapperDetails"].length > 0 && states["isTapper"] ? states["tapperDetails"] : [],
            "drug_name": states["externalBrandName"] ? states["externalBrandName"] : "",
            "generic_name": states["externalGenName"] ? states["externalGenName"] : "",
            "dosage_type": states["externalDosageType"] ? states["externalDosageType"] : "",
            "dosage_strength": states["externalDosStrength"] ? states["externalDosStrength"] : "",
            "selective_days": states["Selected_days"].length > 0 ? states["Selected_days"].map(item => this.convertDayToNumber(item)) : [],
            'fo_external_drug_id': states['fo_external_drug_id'] ? states['fo_external_drug_id'] : null,
            "nurse_profile_id": states.selectedNurse?.nurse_id || null,
            "nurse_name": nurseName,
          }]
        }
      }
      try {
        this.LoaderFunction(true)
        RestAPIService[method](datas, Serviceurls.IP_MEDICATION_GET)
          .then(response => {
            if (response.data.status === "success") {
              this.handleClear();
              // this._getIpMedicationDetails();
              this.LoaderFunction(false)
              this.setState({ isAdd: false })
              this.responseSuccessErrorMessage(response.data.message, true);
              this.getPresctiptionUsageList();
            }
          })
          .catch(error => {
            if (error?.response?.data?.status === "fail") {
              this.LoaderFunction(false)
              this.setState({ isAdd: false })
              this.responseSuccessErrorMessage(error.response.data.message, false);
            }
          });
      } catch (e) {
        this.setState({ isAdd: false })
        this.responseSuccessErrorMessage(e.message, false);
      }
    } else {
      this.setState({ isAdd: false })
      this.responseSuccessErrorMessage(Message, false)
    }
  }

  PopupClose = () => {
    this.setState({
      deletedPopup: false,
      brand_name: "",
      medication_id: null
    })
  }

  removeDataList = () => {
    let { medication_id } = this.state;
    try {
      RestAPIService.delete(`${Serviceurls.IP_MEDICATION_GET}?line_item_id=${medication_id ? medication_id : null}`)
        .then(response => {
          if (response.data.status === "success") {
            this.setState({
              deletedPopup: false,
              brand_name: "",
              medication_id: null
            }, () => {
              this.responseSuccessErrorMessage(response.data.message, true);
              this._getIpMedicationDetails();
            })
          }
        })
        .catch(error => {
          if (error?.response?.data?.status === "fail") {
            this.responseSuccessErrorMessage(error.response.data.message, false);
          }
        });
    } catch (e) {
      this.responseSuccessErrorMessage(e.message, false);
    }
  }
  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value.trimStart();
    let isValid = false;
    let states = this.state;
    switch (name) {
      case "quantity":
        isValid = CommonValidation.NumberWithDot(value);
        if (value === "" || isValid) {
          states["quantity"] = value;
        }
        break;
      default:
        states[name] = value;
        break;
    }
    this.setState({
      states
    })
  }

  DisableRouteOption = (option, IP_routeList) => {
    let Dosage_Type = this.state.mediItem.dosage_type
    if (Dosage_Type === "Ampules" || Dosage_Type === "Injection") {
      return (
        option === IP_routeList[3] || option === IP_routeList[4] || option === IP_routeList[5] || option === IP_routeList[6] || option === IP_routeList[7] || option === IP_routeList[8] || option === IP_routeList[9] || option === IP_routeList[10] || option === IP_routeList[11] || option === IP_routeList[12]
      )
    } else if (Dosage_Type === "Tablet") {
      return (
        option === IP_routeList[0] || option === IP_routeList[3] || option === IP_routeList[4] || option === IP_routeList[5] || option === IP_routeList[6] || option === IP_routeList[9] || option === IP_routeList[1] || option === IP_routeList[2] || option === IP_routeList[10] || option === IP_routeList[11] || option === IP_routeList[12]
      )
    } else if (Dosage_Type === "Steroid Tablets" || Dosage_Type === "Capsule Sr" || Dosage_Type === "Syrup" || Dosage_Type === "Biscuit") {
      return (
        option === IP_routeList[0] || option === IP_routeList[3] || option === IP_routeList[4] || option === IP_routeList[5] || option === IP_routeList[6] || option === IP_routeList[8] || option === IP_routeList[1] || option === IP_routeList[2] || option === IP_routeList[9] || option === IP_routeList[10] || option === IP_routeList[11] || option === IP_routeList[12]
      )
    } else if (Dosage_Type === "Capsule") {
      return (
        option === IP_routeList[0] || option === IP_routeList[1] || option === IP_routeList[2] || option === IP_routeList[3] || option === IP_routeList[8] || option === IP_routeList[9] || option === IP_routeList[6] || option === IP_routeList[10] || option === IP_routeList[11] || option === IP_routeList[12]
      )
    }
  }

  handleFocus = () => {
    const { t } = this.props;
    let { pharma_name } = this.state;
    if (pharma_name === "") {
      this.setState({ focusError: "Select Pharmacy" });
      this.responseSuccessErrorMessage(t("SelectPharmacy"), false);
    }
  }

  getExternalDrugSearchList = (brandName, genericName) => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_OPT_EXTERNAL_DRUG + `?brand_name=${brandName}&generic_name=${genericName}`)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              dupExternalDrugList: response?.data?.data ? response?.data?.data : []
            }, () => {
              const uniqueDrugsObj = this.state.dupExternalDrugList.reduce((acc, drug) => {
                const key = drug?.drug_name?.trim().toUpperCase(); // Normalize drug_name

                if (!acc[key]) {
                  acc[key] = {
                    drug_name: drug.drug_name,
                    generic_name: [
                      {
                        generic_name: drug.generic_name,
                        dosage_type: drug.dosage_type,
                        dosage_strength: drug.dosage_strength,
                        fo_external_drug_id: drug.fo_external_drug_id
                      }
                    ]
                  };
                } else {
                  const existingGeneric = acc[key].generic_name?.find(
                    (g) => g.generic_name === drug.generic_name &&
                      g.dosage_type === drug.dosage_type &&
                      g.dosage_strength === drug.dosage_strength
                  );

                  if (!existingGeneric) {
                    acc[key].generic_name.push({
                      generic_name: drug.generic_name,
                      dosage_type: drug.dosage_type,
                      dosage_strength: drug.dosage_strength
                    });
                  }
                }
                return acc;
              }, {});

              const uniqueDrugsArray = Object.values(uniqueDrugsObj);

              this.setState({
                ExternalDrugList: uniqueDrugsArray
              }, () => {
                if (this.state.isEdit) {
                  let genericSuggList = this.state.ExternalDrugList?.find((item) => item?.drug_name === this.state.externalBrandName)
                  this.setState({
                    genericSuggList: genericSuggList ? genericSuggList?.generic_name : []
                  })
                }
              });
            });
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.responseSuccessErrorMessage(error.response.data.message, false)
          } else {
            this.responseSuccessErrorMessage(error.message, false)
          }
        })
    } catch (error) {
      this.responseSuccessErrorMessage(error.message, false)
    }
  }

  renderFreeTextField(label, statekey, value, width) {
    const { t } = this.props;
    let states = this.state;
    return (
      statekey === "externalBrandName" ?
        <Autocomplete
          size='small'
          sx={{ width: width ? width : '27.5vw' }}
          clearIcon
          freeSolo
          autoSelect={false}
          options={this.state.ExternalDrugList ? this.state.ExternalDrugList : []}
          getOptionLabel={option => typeof (option) === "string" ? option : option.drug_name}
          value={this.state.externalBrandName ? this.state.externalBrandName : ''}
          onChange={(e, value) => {
            this.setState({
              externalBrandName: value?.drug_name,
              externalGenName: '',
              externalDosageType: '',
              externalDosStrength: '',
              externalRoute: '',
              fo_external_drug_id: null,
            }, () => {
              if (value?.generic_name?.length === 1) {
                this.setState({
                  externalGenName: value?.generic_name[0]?.generic_name,
                  externalDosStrength: value?.generic_name[0]?.dosage_strength,
                  externalDosageType: value?.generic_name[0]?.dosage_type,
                  fo_external_drug_id: value?.generic_name[0]?.fo_external_drug_id || null,
                })
              } else {
                this.setState({
                  genericSuggList: value?.generic_name ? value?.generic_name : []
                })
              }
            })
          }}
          renderInput={(params) => <TextField {...params}
            onChange={(e) => {
              if (e.target.value?.length > 0) {
                states.externalBrandName = e.target.value
                this.setState({
                  states
                }, () => this.dobounceApiSearch(e.target.value, ''))
              } else {
                this.setState({
                  dupExternalDrugList: [],
                  ExternalDrugList: [],
                  externalBrandName: '',
                  externalGenName: '',
                  externalDosageType: '',
                  externalDosStrength: '',
                  externalRoute: '',
                  fo_external_drug_id: '',
                })
              }
            }}
            label='Drug Name*' />}
        />
        :
        statekey === "externalGenName" ?
          <Autocomplete
            size='small'
            sx={{ width: width ? width : '27.5vw' }}
            clearIcon
            freeSolo
            autoSelect={false}
            options={this.state.genericSuggList ? this.state.genericSuggList : []}
            getOptionLabel={option => typeof (option) === "string" ? option : option.generic_name}
            value={this.state.externalGenName ? this.state.externalGenName : ''}
            onChange={(e, value) => {
              this.setState({
                externalGenName: value?.generic_name,
                externalDosStrength: value?.dosage_strength,
                externalDosageType: value?.dosage_type,
              })
            }}
            renderInput={(params) => <TextField {...params}
              onChange={(e) => {
                this.setState({
                  externalGenName: e.target.value
                })
              }}
              label={label} />}
          />
          :
          statekey === "externalDosageType" ?
            <Autocomplete
              disableClearable
              value={value ? states[value] : ""}
              sx={{ width: width ? width : "13.4vw" }}
              size="small"
              options={Medication_dosages}
              getOptionLabel={option => typeof (option) === "string" ? option : option.label}
              onChange={(event, newRoute) => {
                states["externalDosageType"] = newRoute.label
                this.setState({
                  states
                })
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t(label)}
                  autoComplete="off"
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
            /> :
            statekey === "externalRoute" ?
              <Autocomplete
                disableClearable
                value={value ? states[value] : ""}
                sx={{ width: width ? width : "13.4vw" }}
                size="small"
                options={IP_routeList}
                getOptionLabel={option => typeof (option) === "string" ? option : option.value}
                onChange={(event, newRoute) => {
                  states["externalRoute"] = newRoute.value
                  states["externalRouteOther"] = ""
                  this.setState({
                    states
                  })
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t(label)}
                    autoComplete="off"
                    size="small"
                    InputProps={{
                      ...params.InputProps,
                    }}
                  />
                )}
              />
              :
              <TextField
                sx={{ width: width ? width : "10vw" }}
                size="small"
                autoComplete="off"
                label={t(label)}
                name={statekey}
                value={value ? states[value] : ""}
                onChange={this.handleChange}
              />
    )
  }
  renderTextBox(label, statekey, value, width) {
    const { t } = this.props;
    let states = this.state;
    return (
      <div id="eMed_srvConfig_divs">
        {statekey === "pharma_name" ?
          <Autocomplete
            disableClearable
            value={value ? value : ""}
            sx={{ width: width ? width : "13.4vw", fontSize: "0.9vw", marginRight: "0.5vw", visibility: this.state.isEdit ? 'hidden' : 'visible' }}
            size="small"
            options={states.pharmaData.length != 0 ? states["pharmaData"] : []}
            getOptionLabel={option => typeof (option) === "string" ? option : option.pharmacy_name}
            onChange={(event, newPharma) => {
              this.setState({
                pharma_name: newPharma["pharmacy_name"],
                pharma_id: newPharma["pharmacy_id"],
                focusError: "",

                mediItem: {},
                tapperItem: {},
                open: false,
                duration_mode: "Day(s)",
                duration: null,
                isTapper: false,
                instruction: "",
                tapperDuration_mode: "Day(s)",
                tapperDuration: "",
                tapperStartDate: today,
                tapperUnit_typ: "",
                tapperReduced_typ: "mg",
                tapperDetails: [],
                selectedEditIndex: null,
                tapperFrequency: "",
                focusError: "",
                isEdit: false,
                morning: 0,
                afternoon: 0,
                evening: 0,
                night: 0,
                quantity: null,
                ExternalDrug: "",
                externalBrandName: "",
                externalGenName: "",
                externalDosageType: "",
                externalDosStrength: "",
                externalRoute: "",
                Selected_days: [],
                fo_external_drug_id: null,
              }, () => {
                this.getFrequentDrugInPharma()
                this._getIpMedicationDetails()
              })
            }}
            //  defaultValue={states.pharmaData.length != 0 ? states.pharmaData[0].pharmacy_name : value ? value : ""}
            renderInput={(params) => (
              <TextField
                {...params}
                label={`${t(label)} (${states["pharmaData"].length}) *`}
                autoComplete="off"
                size="small"
                InputProps={{
                  ...params.InputProps,
                }}
                error={value === "" && states["focusError"].length > 0}
              />
            )}
          />
          : statekey === "brand_name" ?
            <Autocomplete
              disableClearable
              value={value ? value : ""}
              sx={{ width: width ? width : "13.4vw" }}
              size="small"
              options={states.brandnameList.length != 0 ? states["brandnameList"] : []}
              getOptionLabel={option => typeof (option) === "string" ? option :
                (+this.state.drug_search === 1 ? option.drug_name :
                  `${option.drug_name} ${option?.generic_name ? `- ${option?.generic_name}` : ''}`)
              }
              onChange={(event, newbrand) => {
                states["mediItem"]["brand_name"] = newbrand?.drug_name;
                this.setState({
                  states
                }, () => {
                  this._getBrandDetails(newbrand?.drug_name, newbrand?.generic_name);
                })
              }}
              onInputChange={(event, newBrand) => {
                let previousBrand_name = JSON.stringify(states["mediItem"]["brand_name"]);
                if (states["mediItem"]["brand_name"] !== newBrand) {
                  states["mediItem"]["brand_name"] = ''
                };
                if (previousBrand_name != JSON.stringify(newBrand)) {
                  states["mediItem"]["drug_ms_id"] = null;
                  states["mediItem"]["generic_name"] = "";
                  states["mediItem"]["dosage_type"] = "";
                  states["mediItem"]["dosage_strength"] = "";
                  states["tapperItem"]["unit"] = "";
                  states["tapperUnit_typ"] = "";
                  states["tapperReduced_typ"] = "mg";
                  states["tapperDetails"] = "";
                  states["isTapper"] = false;
                }
                this.setState({
                  states,
                  genericList: previousBrand_name != JSON.stringify(newBrand) ? [] : this.state.genericList
                })
                this.debounceBrandName(newBrand);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t(label) + "*"}
                  autoComplete="off"
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                  }}
                  onFocus={this.handleFocus}
                />
              )}
            />
            : statekey === "generic_name" ?
              <Autocomplete
                disableClearable
                value={value ? value : ""}
                sx={{ width: width ? width : "13.4vw" }}
                size="small"
                options={states.genericList.length != 0 ? states["genericList"] : []}
                getOptionLabel={option => typeof (option) === "string" ? option : option.display_name ? option.display_name : option.generic_name}
                onChange={(event, newGeneric) => {
                  let strength = newGeneric["drug_strength"] ? newGeneric["drug_strength"] : '';
                  let numericAlone = strength.match(/(\d+)/);
                  let dosage_type = (newGeneric['dosage_type']).toUpperCase();
                  states["mediItem"]["drug_ms_id"] = newGeneric["drug_ms_id"];
                  states["mediItem"]["generic_name"] = newGeneric["generic_name"];
                  states["mediItem"]["dosage_type"] = newGeneric["dosage_type"];
                  states["mediItem"]["dosage_strength"] = newGeneric["drug_strength"];
                  states["mediItem"]["stock_in_quantity"] = newGeneric["stock_in_quantity"];
                  states["tapperItem"]["unit"] = (newGeneric["dosage_type"] && (dosage_type === "STEROID TABLETS") ? numericAlone[0] : (dosage_type === "DROP" || dosage_type?.toLowerCase()?.includes('drop')) ? 1 : "");
                  states["tapperUnit_typ"] = (newGeneric['dosage_type'] && (dosage_type === "STEROID TABLETS") ? "mg" : "Drop(s)");
                  states["isTapper"] = (newGeneric['dosage_type'] && (dosage_type === "STEROID TABLETS" || dosage_type === "DROP" || dosage_type?.toLowerCase()?.includes('drop'))) ? true : false;
                  this.setState({
                    states
                  })
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t(label)}
                    autoComplete="off"
                    size="small"
                    InputProps={{
                      ...params.InputProps,
                    }}
                    onFocus={this.handleFocus}
                  />
                )}
              />
              : statekey === "route" ?
                <Autocomplete
                  disableClearable
                  value={value ? value : ""}
                  sx={{ width: width ? width : "13.4vw" }}
                  size="small"
                  options={(IP_routeList.length != 0 && this.state.pharma_name !== "") ? IP_routeList : []}
                  // getOptionDisabled={
                  //   (option) =>  this.DisableRouteOption(option, IP_routeList)
                  // }
                  getOptionLabel={option => typeof (option) === "string" ? option : option.value}
                  onChange={(event, newRoute) => {
                    states["mediItem"]["route"] = newRoute.value
                    states["mediRouteOther"] = ""
                    this.setState({
                      states
                    })
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t(label)}
                      autoComplete="off"
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                      }}
                      onFocus={this.handleFocus}
                    />
                  )}
                />
                : statekey === "duration_mode" ?
                  <FormControl sx={{ width: width ? width : "10vw", marginRight: "0.5vw" }} size="small">
                    <Select
                      value={value ? value : "Day(s)"}
                      name={statekey}
                      label={t(label)}
                      onChange={(event) => {
                        if (!this.state.isTapper) {
                          this.handleDuration("duration_mode", event.target.value)
                        }
                      }}
                      sx={{ fontSize: "0.9vw" }}
                    >
                      {
                        DurationsList.map((list, index) => (
                          <MenuItem key={index} value={list.label} sx={{ fontSize: "0.8vw" }} >{list.label}</MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>
                  :
                  <TextField
                    sx={{ width: width ? width : "10vw" }}
                    size="small"
                    autoComplete="off"
                    label={t(label)}
                    name={statekey}
                    value={value ? value : ""}
                    InputProps={{
                      readOnly: (statekey === "dosage_type" || statekey === "dosage_strength" || (statekey === "quantity" && !(this.state.isTapper)))
                    }}
                    onChange={this.handleChange}
                  />}
      </div>
    )
  }

  getPresctiptionUsageList = () => {
    try {
      RestAPIService.getAll(Serviceurls.IP_MEDICATION_USAGE_LIST)
        .then((response) => {
          if (response.data.status === 'success') {
            const usageList = (response?.data?.data || []).map(item => ({
              id: item.id,
              label: item.instructions,
              is_added: true
            }));
            this.setState({
              prescriptionUsage: usageList || [],
            });
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  postPresctiptionUsageList = () => {
    try {
      let data = {
        "instructions": this.state.prescUsage
      }
      if (this.state.prescUsage === null || this.state.prescUsage === '') {
        this.setState({ postUsageLoad: false })
        this.errorMessage('Please Enter Usage')
      } else {
        RestAPIService.create(data, Serviceurls.IP_MEDICATION_USAGE_LIST)
          .then((response) => {
            if (response.data.status === 'success') {
              this.successMessage(response.data.message)
              const newUsage = {
                id: response.data.data?.id,
                label: this.state.prescUsage,
                is_added: true
              };
              this.setState({
                selectedUsage: newUsage,
                instruction: this.instructions(this.state.prescUsage),
                prescriptionUsage: [...this.state.prescriptionUsage, newUsage]
              }, () => {
                this.setState({ openAddNew: false, postUsageLoad: false, prescUsage: null })
                this.getPresctiptionUsageList()
              })
            }
          }).catch((error) => {
            this.setState({ postUsageLoad: false })
            if (error?.response?.data?.message) {
              this.errorMessage(error.response.data.message)
            } else {
              this.errorMessage(error.message)
            }
          })
      }
    } catch (error) {
      this.setState({ postUsageLoad: false })
      this.errorMessage(error.message)
    }
  }

  deletePresctiptionUsageList = (item) => {
    try {
      let data = {}
      RestAPIService.delete(Serviceurls.IP_MEDICATION_USAGE_LIST + '?id=' + item?.id, data)
        .then((response) => {
          if (response.data.status === 'success') {
            this.successMessage(response.data.message)
            this.setState({
              selectedUsage: item?.id === this.state.selectedUsage?.id ? null : this.state.selectedUsage,
              instruction: item?.id === this.state.selectedUsage?.id ? '' : this.state.instruction
            })
            this.getPresctiptionUsageList()
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getUsageOptions = () => {
    const predefinedInstructions = [
      { id: 'before_food', label: 'Before Food', is_added: false },
      { id: 'after_food', label: 'After Food', is_added: false },
      { id: 'external_use', label: 'External Use', is_added: false },
      { id: 'empty_stomach', label: 'Empty Stomach', is_added: false },
      { id: 'with_food', label: 'With Food', is_added: false },
      { id: "STAT", label: "STAT", is_added: false },
      { id: "SOS", label: "SOS", is_added: false },
    ];

    const customInstructions = (this.state.prescriptionUsage || []).map(item => ({
      ...item,
      is_added: true
    }));

    const allOptions = [...predefinedInstructions, ...customInstructions];

    return allOptions;
  }

  // Helper method for getOptionLabel
  getOptions = (option) => {
    return typeof option === 'string' ? option : option.label || '';
  }

  renderNewUsagePopup = () => {
    try {
      return (
        <Dialog open={this.state.openAddNew} >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography fontSize={'0.9dvw'} fontWeight={600}>Add New Usage</Typography>
            <Button
              className='Common_Btn_Min_Width'
              onClick={() => this.setState({ openAddNew: false, prescUsage: null })}
            >
              <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
            </Button>
          </DialogTitle>
          <DialogContent>
            <TextField
              size='small'
              sx={{ width: '20dvw', mr: '1dvw' }}
              value={this.state.prescUsage}
              onChange={(e) => {
                if (e.target.value?.length <= 50) {
                  this.setState({ prescUsage: e.target.value })
                } else {
                  this.errorMessage('Allowed Only 50 Characters')
                }
              }}
              placeholder='Enter Usage'
            />
            <Button variant='contained' sx={{ textTransform: 'capitalize' }}
              disabled={this.state.postUsageLoad}
              onClick={() => this.setState({ postUsageLoad: true }, () => this.postPresctiptionUsageList())}
            >Add</Button>
          </DialogContent>
        </Dialog>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }



  handleInstructionChange = (value) => {
    if (!value) {
      this.setState({
        selectedUsage: null,
        instruction: ''
      });
      return;
    }

    const label = value?.label || value || "";

    const instructionValue = this.instructions(label);

    this.setState({
      selectedUsage: value,
      instruction: instructionValue
    });
  }


  instructions = (item) => {
    let value = '';
    switch (item) {
      case 'Before Food':
        value = 'BF'
        break;
      case 'After Food':
        value = 'AF'
        break;
      case 'External Use':
        value = 'EU'
        break;
      case 'Empty Stomach':
        value = 'ES'
        break;
      case 'With Food':
        value = 'WF'
        break;
      default:
        value = item;
        break;
    }
    return value;
  }
  renderInstructionAutocomplete = () => {
    const { t } = this.props;
    let { mediItem, pharma_name } = this.state;
    let disable = (pharma_name === "" ||
      ((mediItem["drug_ms_id"] !== "") &&
        (mediItem["dosage_type"] === 'Steroid Tablets' ||
          mediItem["dosage_type"] === "Drop")) ||
      this.state.withOutAppointment?.is_ip);

    const usageOptions = this.getUsageOptions();
    return (
      <Autocomplete
        clearIcon
        size='small'
        sx={{ width: '100%' }}
        options={usageOptions}
        getOptionLabel={(option) => {
          if (typeof option === 'string') return option;
          return option?.label || '';
        }}
        value={this.state.selectedUsage}
        onChange={(e, value) => this.handleInstructionChange(value)}
        disabled={disable}
        renderInput={(params) => <TextField {...params} label={'Select Usage'} />}
        renderOption={(props, item) => {
          return (
            <Box component={'div'} display={'flex'} justifyContent={'space-between'} key={props["data-option-index"]}>
              <Box component="li" {...props} width={'100%'}>
                <Typography>{item?.label}</Typography>
              </Box>
              {item?.is_added ?
                <Button className='Common_Btn_Min_Width'
                  onClick={(e) => {
                    e.stopPropagation();
                    this.deletePresctiptionUsageList(item);
                  }}
                ><DeleteIcon color='error' /></Button> : null}
            </Box>
          )
        }}
        PaperComponent={({ children }) => {
          return (
            <Paper>
              {children}
              <Divider />
              <Button
                color="primary"
                fullWidth
                sx={{ justifyContent: "flex-start", pl: 2, textTransform: 'capitalize' }}
                onMouseDown={(e) => {
                  e.preventDefault();
                  this.setState({ openAddNew: true });
                }}
              >
                Add Usage
              </Button>
            </Paper>
          )
        }}
      />
    );
  }

  renderMaen = (label, statekey) => {
    const { t } = this.props;
    let { mediItem, pharma_name } = this.state;
    let disable = (pharma_name === "" || ((mediItem["drug_ms_id"] !== "") && (mediItem["dosage_type"]) === 'Steroid Tablets' || (mediItem["dosage_type"]) === "Drop"));
    return (
      <Stack className="eMed_medication_tapperSubDiv" direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
        <Typography id="eMed_medication_maenChipTxt">{t(label)}</Typography>
        <Stack direction="row" justifyContent="center" alignItems="center" spacing={0.5}>
          {MaenList && MaenList.length > 0 ? MaenList.map((item, index) => {
            let selectedValue = (statekey === "morning" && item.value === this.state.morning || statekey === "afternoon" && item.value === this.state.afternoon || statekey === "evening" && item.value === this.state.evening || statekey === "night" && item.value === this.state.night)
            return (
              <Box
                key={index}
                sx={{ backgroundColor: (selectedValue && !disable) ? Colors.themeDark : "#FAF9F9", color: (selectedValue && !disable) ? Colors.white : Colors.black, borderColor: (selectedValue && !disable) ? Colors.themeDark : Colors.lightGray }}
                id="eMed_medication_maenChip" onClick={() => !disable ? this.handleDuration(statekey, item.value) : null}>{item.label}</Box>
            )
          }) : null}
        </Stack>
      </Stack>
    )
  }
  renderTextBoxs = (label1, statekey1, value1, width, statekey2, value2, width1) => {
    const { t } = this.props;
    let states = this.state;
    const currentDate = new Date();
    const admissionDate = states?.patientData?.admitted_date
      ? new Date(states.patientData?.admitted_date)
      : states?.patientData?.admission_date
        ? new Date(states.patientData?.admission_date)
        : currentDate;

    return (
      <div>
        {
          statekey1 === "tapperStartDate" ?
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                // open={states["open"]}
                // onOpen={() => { this.setState({ open: true }) }}
                // onClose={() => { this.setState({ open: false }) }}
                inputFormat="dd-MM-yyyy"
                minDate={admissionDate}
                label={label1 ? t(label1) + "*" : ""}
                name={statekey1}
                value={value1 ? value1 : null}
                autoComplete="off"
                onChange={(value) => {
                  states["tapperStartDate"] = value;
                  this.setState({
                    states
                  })
                }
                }
                renderInput={(params) => <TextField onKeyDown={(e) => e.preventDefault()} size="small" sx={{ width: width ? width : "13.4vw", margin: "0.2vw" }} {...params} onClick={() => { this.setState({ open: true }) }} />}
              />
            </LocalizationProvider>
            : statekey1 === "tapperFrequency" ?
              <FormControl sx={{ width: width ? width : "13.2vw" }} size="small">
                <InputLabel>{t(label1)}</InputLabel>
                <Select
                  value={value1 ? value1 : ""}
                  name={statekey1}
                  label={t(label1)}
                  onChange={(event) => { this.setState({ tapperFrequency: event.target.value }) }}
                  sx={{ fontSize: "0.9vw" }}
                >
                  {
                    Taper_Med_Frequency.map((list, index) => (
                      <MenuItem key={index} value={list.value} sx={{ fontSize: "0.8vw" }} >{list.label}</MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
              : <Box component={'div'} className=" eMed_medication_txtbox">
                <TextField
                  sx={{ width: width ? width : "10vw" }}
                  size='small'
                  autoComplete="off"
                  className='eMed_temp_txt'
                  label={label1 ? t(label1) : ""}
                  name={statekey1}
                  value={value1 ? value1 : ""}
                  onChange={(e) => statekey1 === "tapperDuration" ? this.handleDuration(statekey1, e.target.value) : this.onChangeHandler(statekey1, e.target.value)}
                />
                {(statekey2 === "tapperUnit_typ" || statekey2 === "tapperReduced_typ") ? <TextField
                  sx={{ width: width1 ? width1 : "10vw" }}
                  size='small'
                  autoComplete="off"
                  className='eMed_temp_txt'
                  name={statekey2}
                  value={value2 ? value2 : ""}
                  InputProps={{
                    readOnly: true
                  }}
                // onChange={(e) => this.onChangeHandler(statekey2, e.target.value)}
                /> :
                  <FormControl sx={{ width: width1 ? width1 : "3.4vw" }} size='small'>
                    <Select
                      name={statekey2}
                      value={value2 ? value2 : ""}
                      onChange={(e) => { statekey2 === "tapperDuration_mode" ? this.handleDuration(statekey2, e.target.value) : this.onChangeHandler(statekey2, e.target.value) }}
                      sx={{ fontSize: "0.95vw" }}
                    >
                      {statekey2 === "tapperDuration_mode" ?
                        DurationsList.map((list, index) => (
                          <MenuItem key={index} value={list.label} sx={{ fontSize: "0.75vw" }} >{list.label}</MenuItem>
                        )) : null
                      }
                    </Select>
                  </FormControl>
                }
              </Box>}
      </div>
    )
  }

  handleTapperAdd = () => {
    const { t } = this.props;
    let states = this.state;
    let Message = "";
    let tapperDosage = states["mediItem"]["dosage_type"];
    let frequency = (tapperDosage).toUpperCase() === "STEROID TABLETS" ? "" : states.tapperFrequency;
    let reducedBy = (tapperDosage).toUpperCase() === "STEROID TABLETS" ? states["tapperItem"]["reduced_by"] : "";
    let validDate = false;

    let d = new Date(states["tapperStartDate"])
    if (d.toString() != "Invalid Date") {
      validDate = true
    }

    if (validDate && ((states["tapperItem"]["unit"]) !== "") &&
      ((states["tapperDuration"]) !== "") &&
      ((((tapperDosage).toUpperCase() === "DROP" || (tapperDosage)?.toLowerCase()?.includes('drop')) && (states.tapperFrequency) !== "") || ((tapperDosage).toUpperCase() === "STEROID TABLETS" && (states.tapperReduced_typ).trim() != ""))
    ) {
      let dosageCountLabel = (tapperDosage).toUpperCase() === "STEROID TABLETS" ? 'mg' : 'Drop(s)'
      let frequencyLabel = dosageCountLabel === "Drop(s)" ? (frequency == 1) ? ' time a day' : ' times a day' : 'morning - after food'
      let duration = states["tapperDuration"];

      if (states.tapperDuration_mode === "Week(s)") {
        duration = parseInt(states.tapperDuration) * 7
      } else if (states.tapperDuration_mode === "Month(s)") {
        duration = parseInt(states.tapperDuration) * 30
      }

      let date = new Date(states["tapperStartDate"]);
      date.setDate(date.getDate() + parseInt(duration));

      if ((states.selectedEditIndex || states.selectedEditIndex == 0)) {
        let details = {
          duration: `${states["tapperDuration"]} ${states["tapperDuration_mode"]}`,
          start_date: states["tapperStartDate"],
          end_date: date,
          frequency: `${frequency} ${frequencyLabel}`,
          no_of_dosage: `${states["tapperItem"]["unit"]} ${dosageCountLabel}`,
          reducedBy: reducedBy
        }
        let newList = states["tapperDetails"].map((item, index) => {
          return index === states.selectedEditIndex ? details : item
        })
        states["tapperDetails"] = JSON.parse(JSON.stringify(newList))
      } else if (!states.selectedEditIndex && states.selectedEditIndex != 0) {
        let details = {
          duration: `${states["tapperDuration"]} ${states["tapperDuration_mode"]}`,
          start_date: states["tapperStartDate"],
          end_date: date,
          frequency: `${frequency} ${frequencyLabel}`,
          no_of_dosage: `${states["tapperItem"]["unit"]} ${dosageCountLabel}`,
          reducedBy: reducedBy
        }
        states["tapperDetails"] = [...this.state.tapperDetails, details];
      }

      if (parseInt(frequency) === 1) {
        frequency = frequency
      } else if (parseInt(frequency) === 12) {
        frequency = 10
      } else if (parseInt(frequency) === 10) {
        frequency = 6
      } else {
        frequency = parseInt(frequency) - 1
      }

      let unitVal = ""
      let calc = parseInt(states["tapperItem"]["unit"]) - parseInt(states["tapperItem"]["reduced_by"])
      if (states["tapperUnit_typ"] === "mg" && calc > 0) {
        unitVal = calc;
      } else {
        unitVal = states["tapperItem"]["unit"];
      }

      let nextStartDate = new Date(date)
      nextStartDate.setDate(nextStartDate.getDate() + 1);
      states["tapperItem"]["unit"] = unitVal + "";
      this.setState({
        states,
        tapperStartDate: nextStartDate,
        tapperFrequency: frequency + "",
        selectedEditIndex: null
      })
    } else {
      let isDrop = states["mediItem"]["dosage_type"] && (states["mediItem"]["dosage_type"]).toUpperCase();
      if (!states["tapperStartDate"]) { Message = `${t("Enter")} ${t("StartDate")}` }
      else if (!states["tapperDuration"]) { Message = `${t("Enter")} ${t("Duration")}` }
      else if (!states["tapperItem"]["unit"]) { Message = `${t("Enter")} ${t("Unit")}` }
      else if ((isDrop !== "DROP" || !(states["mediItem"]["dosage_type"])?.toLowerCase()?.includes('drop')) && !states["tapperItem"]["reduced_by"]) { Message = `${t("Enter")} ${t("Reduceby")}` }
      else if ((isDrop !== "DROP" || !(states["mediItem"]["dosage_type"])?.toLowerCase()?.includes('drop')) && !states["tapperReduced_typ"]) { Message = `${t("Enter")} ${t("ReducedType")}` }
      else if ((isDrop === "DROP" || (states["mediItem"]["dosage_type"])?.toLowerCase()?.includes('drop')) && !states["tapperFrequency"]) { Message = `${t("Enter")} ${t("Frequency")}` }
      if (Message.length > 0) {
        this.responseSuccessErrorMessage(Message, false);
      }
    }
  }

  onEditTaperMed = (item, index) => {
    let states = this.state;
    let tapperDosage = states["mediItem"]["dosage_type"];
    let taperUnit = (item.no_of_dosage).split(" ");
    let duration = (item.duration).split(" ");
    let frequency = (tapperDosage).toUpperCase() !== "STEROID TABLETS" ? (item.frequency).split(" ") : [""];
    states["tapperItem"]["unit"] = taperUnit[0];
    states["tapperItem"]["reduced_by"] = item.reducedBy;
    states["tapperStartDate"] = item.start_date;
    this.setState({
      states,
      tapperDuration: duration[0],
      tapperDuration_mode: duration[1],
      tapperFrequency: frequency[0],
      selectedEditIndex: index,
    })
  }

  onDeleteTaperMed = (item, index) => {
    let { tapperDetails } = this.state;
    let deletedArr = [...tapperDetails]
    deletedArr.splice(index, 1);
    this.setState({
      tapperDetails: JSON.parse(JSON.stringify(deletedArr)),
      selectedEditIndex: null
    })
  }
  renderTapper = () => {
    const { t } = this.props;
    let { tapperItem, mediItem, pharma_name } = this.state;
    let states = this.state;
    let disable = (pharma_name === "" || ((mediItem["drug_ms_id"] !== "") && (mediItem["dosage_type"]) === 'Steroid Tablets' || (mediItem["dosage_type"]) === "Drop" || mediItem['dosage_type']?.toLowerCase()?.includes('drops')));
    return (
      (states["isTapper"] && states["mediItem"]["drug_ms_id"] !== "" && states["pharma_name"] !== "") ?
        <Stack className="eMed_medication_tapperDiv">
          <div className='eMed_medication_rightHead' style={{ backgroundColor: Colors.DataTblHeaderbg }}>
            <p className='eMed_recPayment_rightHead_txt'>{t("DosageType")}</p>
          </div>
          <Stack direction={"column"} alignItems={"center"} justifyContent={"center"} spacing={1}>
            {Taper_Med_Dosages.length > 0 ?
              <Stack id="eMed_medication_chipDiv" direction="row" justifyContent="flex-start" alignItems="center" spacing={1} flexWrap="wrap">
                {Taper_Med_Dosages.map((item, i) => {
                  let dosage = (states["mediItem"]["dosage_type"]).toLowerCase()?.includes('drop') ? 'DROP' : 'STEROID TABLETS'
                  if (item["drug_name"] !== "") {
                    return (<Chip key={i} id="eMed_medication_chip" label={item.label} sx={{ '& .MuiChip-label': { fontSize: "0.8vw" }, '&.MuiChip-icon': { width: "1.5vw", height: "1.5vw" } }}
                      color={'primary'} variant={(states["mediItem"]["dosage_type"]) ? (dosage === item.value) ? 'contained' : "outlined" : ""} />)
                  }
                })}
              </Stack> : null}
            <Stack direction="row" alignItems="center" spacing={1} className="eMed_medication_tapperSubDiv">
              {this.renderTextBoxs("StartDate", "tapperStartDate", states["tapperStartDate"], "13.2vw")}
              {this.renderTextBoxs("Duration", "tapperDuration", states["tapperDuration"], "6vw", "tapperDuration_mode", states["tapperDuration_mode"], "7vw")}
            </Stack>
            <Stack direction="row" alignItems="center" spacing={1} className="eMed_medication_tapperSubDiv">
              {this.renderTextBoxs("Unit", "unit", tapperItem["unit"], "7vw", "tapperUnit_typ", states["tapperUnit_typ"], "6.2vw")}
              {(states["mediItem"]["dosage_type"]) ? ((states["mediItem"]["dosage_type"]).toUpperCase() === "DROP" || states['mediItem']['dosage_type']?.toLowerCase()?.includes('drop')) ?
                this.renderTextBoxs("Frequency", "tapperFrequency", states["tapperFrequency"], "13.2vw")
                : this.renderTextBoxs("Reducedby", "reduced_by", tapperItem["reduced_by"], "7.5vw", "tapperReduced_typ", states["tapperReduced_typ"], "4.7vw") : ""}
            </Stack>
            <Button variant='contained' disabled={this.state.withOutAppointment?.is_ip} size="small" id="eMed_recPayment_btn" onClick={() => { this.handleTapperAdd() }}>{t("Add")}</Button>
            {
              states["tapperDetails"].length > 0 ?
                <div style={{ width: "100%" }}>
                  <div className='eMed_medication_rightHead' style={{ backgroundColor: Colors.DataTblHeaderbg }}>
                    <p className='eMed_recPayment_rightHead_txt'>{t("AddedDetails")}</p>
                  </div>
                  <Stack className="emedhub_recPayment_RightContentBox">
                    <Stack direction="column" justifyContent="center" alignItems="center" spacing={1}>
                      {states["tapperDetails"].map((details, index) => {
                        let newStart = details.start_date ? new Date(details.start_date) : "";
                        let newEnd = details.end_date ? new Date(details.end_date) : "";
                        return (
                          <Stack key={index} direction="row" flex={1} sx={{ width: "100%", marginBottom: '0.6vw' }}>
                            <Stack flex={0.45}>
                              <Typography style={{ fontSize: '0.9vw' }}>{details.duration}</Typography>
                              <Typography style={{ fontSize: '0.9vw' }}>{"(" + DateTime.fromJSDate(newStart).toFormat("dd-MM-yyyy") + " - " + DateTime.fromJSDate(newEnd).toFormat("dd-MM-yyyy") + ")"}</Typography>
                            </Stack>
                            <Stack flex={0.40}>
                              <Typography style={{ fontSize: '0.9vw' }}>{details.frequency}</Typography>
                              <Typography style={{ fontSize: '0.9vw' }}>{details.no_of_dosage}</Typography>
                            </Stack>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" flex={0.15}>
                              <CommonEditButton disable={this.state.withOutAppointment?.is_ip} size="1.5vw" onClick={this.onEditTaperMed.bind(this, details, index)} />
                              <CommonDeleteButton disabled={this.state.withOutAppointment?.is_ip} size="1.5vw" onClick={this.onDeleteTaperMed.bind(this, details, index)} />
                            </Stack>
                          </Stack>
                        )
                      })}
                    </Stack>
                  </Stack>
                </div>
                : null}
          </Stack>
        </Stack> :
        <div>
          <div className='eMed_medication_rightHead' style={{ backgroundColor: Colors.DataTblHeaderbg }}>
            <p className='eMed_recPayment_rightHead_txt'>{t("Duration")}
              {!this.state.isTapper && !disallowed.has(this.state.instruction) ? " *" : ""}
            </p>
            {this.renderTextBox("", "duration_mode", states["duration_mode"], "8vw")}
          </div>
          <Stack className="emedhub_recPayment_RightContentBox">
            <Stack className="eMed_medication_durChipDiv" direction="row" justifyContent="flex-start" alignItems="center" spacing={1} flexWrap={"wrap"}>
              {DurationCounts.map((count, index) => (
                <Box
                  key={index}
                  sx={{ backgroundColor: count === this.state.duration && !disable ? Colors.themeDark : "#FAF9F9", color: count === this.state.duration && !disable ? Colors.white : Colors.black, borderColor: count === this.state.duration && !disable ? Colors.themeDark : Colors.lightGray }}
                  id="eMed_medication_durChip" onClick={() => !disable ? this.handleDuration("duration", count) : null}>{count}</Box>
              )
              )}
            </Stack>
          </Stack>
        </div>
    )
  }

  // Template functionality start
  clearTemplateStates = () => {
    this.setState({
      openPopupAddNew: false,
      templateName: '',
      selectedTemplateName: '',
      templateLoad: false
    })
  }

  postNewTemplateData = () => {
    try {
      this.setState({ templateLoad: true })
      // get line_items if rename
      const existingLineItems = this.state.tempType === "rename" ? this.state.selectedTemplateName?.line_items || [] : [];
      const seenIds = new Set();
      const templateList = this.state.newMedicationRequestList?.map((item) => {
        // find match by drug_name
        const existingItem = existingLineItems?.find((line) =>
          line?.drug_ms
            ? line?.drug_ms === item?.drug_ms_id
            : line?.drug_ms__drug_name?.toLowerCase() === item?.brand_name?.toLowerCase()
        );
        if (existingItem?.id) {
          seenIds.add(existingItem.id);
        }
        return ({
          "id": existingItem?.id || null,
          "clinic_id": this.state.clinic_id,
          "is_tapper": item.tapper?.length > 0,
          "drug_ms": item.drug_ms_id || null,
          "morning": item.morning || 0,
          "afternoon": item.afternoon || 0,
          "evening": item.evening || 0,
          "night": item.night || 0,
          "route": item.route || "",
          "duration": item.duration || 0,
          "duration_type": item.tapper?.length > 0 ? "" : item.duration_type || "Day(s)",
          "quantity": item.quantity || 0,
          "instructions": item.instructions || "",
          "tapper": item.tapper || [],
          "drug_name": item.brand_name || "",
          "generic_name": item.generic_name || "",
          "dosage_type": item.dosag_type || "",
          "dosage_strength": item.drug_strength || "",
          "selective_days": item.selective_days || [],
          'fo_external_drug_id': item.external_drug_id || null,
        })
      })
      // find deleted ids
      const deleted_ids = [];
      existingLineItems?.forEach((line) => {
        if (line.id && !seenIds.has(line.id)) {
          deleted_ids.push(line.id);
        }
      });
      const data = {
        "template_name": this.state.templateName,
        "line_items": templateList || [],
        "clinic_id": this.state.clinic_id || undefined,
        "template_id": this.state.selectedTemplateName?.template_id || undefined,
        "deleted_ids": this.state.selectedTemplateName?.template_id ? deleted_ids.length > 0 ? deleted_ids : [] : undefined,
      }
      RestAPIService.create(data, Serviceurls.IP_MEDICATION_TEMPLATE_GET)
        .then((response) => {
          if (response.data.status === "success") {
            this.clearTemplateStates()
            this.getTemplateList()
            this.responseSuccessErrorMessage(response.data.message, true)
          } else {
            this.responseSuccessErrorMessage(response.data.message, false)
          }
        }).catch(error => {
          this.responseSuccessErrorMessage(error.response.data.message || error.message, false)
        })
    } catch (error) {
      this.responseSuccessErrorMessage(error.message, false)
    } finally {
      this.setState({ templateLoad: false })
    }
  }

  deleteTemplate = () => {
    try {
      this.setState({ deleteLoad: true })
      RestAPIService.delete(Serviceurls.IP_MEDICATION_TEMPLATE_GET, { "template_id": this.state.deleteTemplateName?.template_id })
        .then((response) => {
          this.responseSuccessErrorMessage(response.data.message, true)
          this.setState({
            openPopupAddNew: false,
            deleteTemplateName: {},
            selectedTemplateName: '',
            deletePopup: false,
            deleteLoad: false,
          })
          this.getTemplateList()
        }).catch((error) => {
          this.setState({ deleteLoad: false })
          this.responseSuccessErrorMessage(error?.response?.data?.message || error.message, false)
        })
    } catch (error) {
      this.setState({ deleteLoad: false })
      this.responseSuccessErrorMessage(error.message, false)
    }
  }

  renderTemplate = () => {
    const { templateList, selectedTemplateName, newMedicationRequestList } = this.state;
    const onChange = (e, value) => {
      this.setState({ selectedTemplateName: value, fromTemplate: true },
        () => {
          if (!value) return;
          const data = value?.line_items?.map((item) => ({
            "is_tapper": item.tapper?.length > 0,
            "drug_ms": item.drug_ms || null,
            "morning": item.morning || 0,
            "afternoon": item.afternoon || 0,
            "evening": item.evening || 0,
            "night": item.night || 0,
            "route": item.route || "",
            "duration": item.duration || 0,
            "duration_type": item.tapper?.length > 0 ? "" : item.duration_type || "Day(s)",
            "quantity": item.quantity || 0,
            "instructions": item.instructions || "",
            "tapper": item.tapper || [],
            "drug_name": item.drug_ms ? "" : item.drug_ms__drug_name || "",
            "generic_name": item.drug_ms ? "" : item.drug_ms__generic_name || "",
            "dosage_type": item.drug_ms ? "" : item.drug_ms__dosagetype__dosage_type || "",
            "dosage_strength": item.drug_ms ? "" : item.drug_ms__drug_strength || "",
            "fo_external_drug_id": null,
            "selective_days": item.selective_days || [],
          }))
          this.handleAdd(data)
        })
    }

    const onDelete = (e, option) => {
      e.stopPropagation();
      this.setState({
        tempType: 'delete',
        deleteTemplateName: option,
        deletePopup: true
      });
    }

    const onAddTemplate = (e) => {
      this.setState({
        openPopupAddNew: true,
        tempType: 'Add',
        selectedTemplateName: null,
        templateName: ''
      })
    }

    const disableSlct = (newMedicationRequestList?.length === 0 && templateList?.length === 0);
    const checkUserAccess = this.props.is_From_IpNotes ? disableSlct :
      CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Medication", "SubTab")?.editAccess ?
        (this.state.withOutAppointment?.is_ip || disableSlct) : true;

    return (
      <Autocomplete
        clearIcon
        size='small'
        disabled={checkUserAccess}
        sx={{ width: '14vw' }}
        options={templateList || []}
        getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.template_name || ""}
        isOptionEqualToValue={(option, value) => option.template_id === value?.template_id}
        value={selectedTemplateName || null}
        onChange={onChange}
        renderOption={(props, option) => {
          return (
            <li {...props} style={{ padding: "0vh 1.5vh" }}>
              <ListItem sx={{ display: 'flex', justifyContent: 'space-between', padding: 0, margin: 0 }}>
                <ListItemText primary={option?.template_name && option?.template_name?.length > 30 ?
                  <Tooltip placement='top' title={option?.template_name}>{<div>{option?.template_name?.slice(0, 21) + '...'}</div>}</Tooltip>
                  : option?.template_name} />
                <IconButton
                  edge="end"
                  color="error"
                  onClick={(e) => onDelete(e, option)}
                >
                  <Tooltip placement='top' title={"Delete"} arrow>
                    <DeleteIcon sx={{ height: "2.5vh", width: "2.5vw" }} /> </Tooltip>
                </IconButton>
              </ListItem>
            </li>
          );
        }}
        renderInput={(params) => <TextField
          {...params}
          label='Select Template'
        />}
        PaperComponent={({ children }) => {
          return (
            <Paper sx={{ maxHeight: '25vw', overflow: 'scroll' }}>
              {children}
              <Divider />
              <Button
                color="primary"
                fullWidth
                disabled={newMedicationRequestList?.length === 0}
                sx={{ justifyContent: "flex-start", pl: 2, textTransform: 'capitalize' }}
                onMouseDown={onAddTemplate}
              >
                Add Template
              </Button>
              {this.state.selectedTemplateName ?
                <Button
                  color="primary"
                  fullWidth
                  disabled={newMedicationRequestList?.length === 0}
                  sx={{ justifyContent: "flex-start", pl: 2, textTransform: 'capitalize' }}
                  onMouseDown={(e) => {
                    this.setState({ openPopupAddNew: true, tempType: 'rename', templateName: this.state.selectedTemplateName?.template_name })
                  }}
                >
                  Rename
                </Button>
                : null
              }
            </Paper>
          )
        }}
      />
    )
  }

  renderTemplatePopup = () => {
    try {
      const { openPopupAddNew, tempType, templateName, templateLoad } = this.state;
      const title = titleMap[tempType] || "Template";

      const closePopup = () => this.setState({ openPopupAddNew: false, templateName: "" });

      return (
        <Modal open={openPopupAddNew}
          keepMounted
          disableEnforceFocus
          styles={{
            content: {
              outline: "none",
              boxShadow: "none",
            },
          }}>
          <Box className="eMed_Doc_Notes_Prescrip_Fav_Pop_Up">
            {/* Header */}
            <Box display="flex" justifyContent="space-between" p="0.5vw" alignItems="center">
              <Typography fontSize="0.9vw" fontWeight={600}> {title} </Typography>
              <Button className="Common_Btn_Min_Width" onClick={closePopup}>
                <Box
                  component="img"
                  src={ImagePaths.LabCloseButton.default}
                  height="1.1vw"
                  width="1.1vw"
                />
              </Button>
            </Box>

            {/* Input */}
            <Box ml="2.5vw">
              <TextField
                size="small"
                sx={{ width: "20vw" }}
                label="Enter Template Name*"
                autoComplete="off"
                inputProps={{ maxLength: 50 }}
                value={templateName}
                onChange={(e) => this.setState({ templateName: e.target.value })}
              />
            </Box>

            {/* Footer Actions */}
            <Box display="flex" justifyContent="center" alignItems="center" height="3vw" gap="1vw">
              <Button
                sx={{ height: "2vw", width: "5vw", textTransform: "capitalize" }}
                variant="outlined"
                onClick={() => this.setState({ templateName: "" })}
              >
                Clear
              </Button>
              <Button
                sx={{ height: "2vw", width: "5vw", textTransform: "capitalize" }}
                variant="contained"
                onClick={this.postNewTemplateData}
                disabled={!templateName?.trim() || templateLoad}
              >
                {tempType === "rename" ? "Update" : "Add"}
              </Button>
            </Box>
          </Box>
        </Modal>
      );
    } catch (error) {
      this.errorMessage(error.message);
    }
  };
  // Temaplate functionality end

  renderLeftMedicationScreen = () => {
    try {
      const { fromBillMedication } = this.props
      let UserData = JSON.parse(localGetItem("loggedInUserInfo"));
      this.state.newMedicationRequestList?.forEach((element, index) => { element.sno = index + 1 })
      this.state.newMedicationReturnList?.forEach((element, index) => { element.sno = index + 1 })
      this.state.newMedicationCancelledList?.forEach((element, index) => { element.sno = index + 1 })
      const checkUserAccess = this.props.is_From_IpNotes ? false :
        CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Medication", "SubTab")?.editAccess ? this.state.withOutAppointment?.is_ip : true;
      const reqColumn = [
        {
          field: 'created_date', headerName: 'Date & Time', flex: 0.143,
          renderCell: (params) => {
            let date = params?.row?.created_date
            return (
              <Box component={'div'}>
                {date ? date?.length > 10 ?
                  <Tooltip placement="top" title={date}><Typography>{date?.slice(0, 10) + '...'}</Typography></Tooltip> :
                  <Typography>{date}</Typography> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'brand_name', headerName: 'Brand Name', flex: 0.143,
          renderCell: (params) => {
            let brandName = params?.row?.brand_name
            let genStreName = params?.row?.generic_name + "|" + params?.row?.drug_strength
            let isHighAlert = params?.row?.is_high_alert && this.state.enable_drug_alert
            return (
              <Box component={'div'}>
                {brandName ? brandName?.length > 15 ?
                  <Tooltip placement="top" title={brandName}><Typography fontSize={'0.9rem'} fontWeight={600} color={isHighAlert ? 'error' : 'inherit'}>{brandName?.slice(0, 10) + '...'}</Typography></Tooltip> :
                  <Typography fontSize={'0.9rem'} fontWeight={600} color={isHighAlert ? 'error' : 'inherit'}>{brandName}</Typography> : '-'}
                {genStreName ? genStreName?.length > 12 ?
                  <Tooltip placement="top" title={genStreName}><Typography fontSize={'0.8rem'} color={isHighAlert ? 'error' : 'inherit'}>{genStreName?.slice(0, 12) + '...'}</Typography></Tooltip> :
                  <Typography fontSize={'0.8rem'} color={isHighAlert ? 'error' : 'inherit'}>{genStreName}</Typography> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'medication', headerName: 'Route/Medication', flex: 0.143,
          renderCell: (params) => {
            let medication = params?.row?.tapper?.length > 0 ? 'Taper' : 'Regular'
            let route = params?.row?.route ? params?.row?.route : '-'
            return (
              <Box component={'div'}>
                {route ? route?.length > 15 ?
                  <Tooltip placement="top" title={route}><Typography fontSize={'0.9rem'} fontWeight={600}>{route?.slice(0, 10) + '...'}</Typography></Tooltip> :
                  <Typography fontSize={'0.9rem'} fontWeight={600}>{route}</Typography> : '-'}
                {medication ? medication?.length > 15 ?
                  <Tooltip placement="top" title={medication}><Typography fontSize={'0.8rem'}>{medication?.slice(0, 15) + '...'}</Typography></Tooltip> :
                  <Typography fontSize={'0.8rem'}>{medication}</Typography> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'morning', headerName: 'M-A-E-N/Duration', flex: 0.143,
          renderCell: (params) => {
            let maen = `${params?.row?.morning ? params?.row?.morning : '0'} - ${params?.row?.afternoon ? params?.row?.afternoon : '0'} - ${params?.row?.evening ? params?.row?.evening : '0'} - ${params?.row?.night ? params?.row?.night : '0'}`
            let durationDays = params?.row?.duration + ' ' + params?.row?.duration_type
            let tapperDetails = params?.row?.tapper
            return (
              params?.row?.tapper?.length === 0 ?
                <Box component={'div'}>
                  {maen ? maen?.length > 18 ?
                    <Tooltip placement="top" title={maen}><Typography fontSize={'0.9rem'} fontWeight={600}>{maen?.slice(0, 18) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9rem'} fontWeight={600}>{maen}</Typography> : '-'}
                  {durationDays ? durationDays?.length > 15 ?
                    <Tooltip placement="top" title={durationDays}><Typography fontSize={'0.8rem'}>{durationDays?.slice(0, 15) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.8rem'}>{durationDays}</Typography> : '-'}
                </Box> :
                <Box component={'div'}>
                  <Tooltip placement="top" arrow title={
                    tapperDetails?.map((item, index) => (
                      <Box component={'div'} key={index} fontSize={'0.8dvw'}>
                        <Typography fontSize={'0.8rem'} fontWeight={600}>{formatDate(item?.start_date?.slice(0, 10)) + ' - ' + formatDate(item?.end_date?.slice(0, 10))}</Typography>
                        <Typography fontSize={'0.8rem'}>{item?.duration}</Typography>
                      </Box>
                    ))
                  }>
                    {tapperDetails?.map((item, index) => {
                      let startEndDate = formatDate(item?.start_date?.slice(0, 10)) + ' - ' + formatDate(item?.end_date?.slice(0, 10))
                      return (
                        <Box component={'div'} key={index}>
                          <Typography fontSize={'0.8rem'} fontWeight={600}>{startEndDate?.slice(0, 16) + '...'}</Typography>
                          <Typography fontSize={'0.8rem'}>{item?.duration}</Typography>
                        </Box>
                      )
                    })}
                  </Tooltip>
                </Box>
            )
          }
        },
        {
          field: 'quantity', headerName: 'Requested Qty', flex: 0.143,
          renderCell: (params) => {
            let number_of_drugs = params?.row?.quantity
            return (
              <Box component={'div'}>
                {number_of_drugs ? number_of_drugs?.length > 10 ?
                  <Tooltip placement="top" title={number_of_drugs}><Typography>{number_of_drugs?.slice(0, 10) + '...'}</Typography></Tooltip> :
                  <Typography>{number_of_drugs}</Typography> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'nurse_name',
          headerName: 'Nurse',
          flex: 0.12,
          renderCell: (params) => {
            let nurseName = params?.row?.nurse_name
            return (
              <Box component={'div'}>
                {nurseName ? nurseName?.length > 15 ?
                  <Tooltip placement="top" title={nurseName}><Typography>{nurseName?.slice(0, 8) + '...'}</Typography></Tooltip> :
                  <Typography>{nurseName || '-'}</Typography> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'status', headerName: 'Status', flex: 0.143,
          renderCell: (params) => {
            let status = params?.row?.medication_status
            return (
              <Box>
                {params?.row?.external_drug_id ?
                  <Box component={'div'} sx={{ backgroundColor: '#e6e6e6', border: '2px solid #a1a1a1', width: '6dvw', borderRadius: '5px', p: '0.3rem', textAlign: 'center' }}>
                    <Typography fontWeight={600} fontSize={'0.9rem'} color={'#808080'}>{'External'}</Typography>
                  </Box> :
                  status === 'Inprogress' ? <Box component={'div'} sx={{ backgroundColor: '#ffd192', border: '2px solid #de7c21', width: '6dvw', borderRadius: '5px', p: '0.3rem', textAlign: 'center' }}>
                    <Typography fontWeight={600} fontSize={'0.9rem'} color={'#de7c21'}>{'Inprogress'}</Typography>
                  </Box> :
                    status === 'Billed' ?
                      <Box component={'div'} sx={{ backgroundColor: '#de7c21', border: '2px solid #65a765', borderRadius: '5px', width: '6dvw', p: '0.3rem', textAlign: 'center' }}>
                        <Typography fontWeight={600} fontSize={'0.9rem'} color={'#65a765'}>{'Completed'}</Typography>
                      </Box> :
                      status === 'Cancelled' ?
                        <Box component={'div'} sx={{ backgroundColor: '#ffefef', border: '2px solid #a80000', borderRadius: '5px', width: '6dvw', p: '0.3rem', textAlign: 'center' }}>
                          <Typography fontWeight={600} fontSize={'0.9rem'} color={'#a80000'}>{'Cancelled'}</Typography>
                        </Box> :
                        status === 'Saved' ?
                          <Box component={'div'} sx={{ backgroundColor: '#e6e6e6', border: '2px solid #a1a1a1', borderRadius: '5px', width: '6dvw', p: '0.3rem', textAlign: 'center' }}>
                            <Typography fontWeight={600} fontSize={'0.9rem'} color={'#808080'}>{'Saved'}</Typography>
                          </Box> :
                          status === 'Transmitted' ?
                            <Box component={'div'} sx={{ backgroundColor: '#e6e6e6', border: '2px solid #a1a1a1', borderRadius: '5px', width: '6dvw', p: '0.3rem', textAlign: 'center' }}>
                              <Typography fontWeight={600} fontSize={'0.9rem'} color={'#808080'}>{'Transmitted'}</Typography>
                            </Box> :
                            <Box component={'div'} sx={{ backgroundColor: '#e6e6e6', border: '2px solid #a1a1a1', borderRadius: '5px', width: '6dvw', p: '0.3rem', textAlign: 'center' }}>
                              <Typography fontWeight={600} fontSize={'0.9rem'} color={'#808080'}>{'Not Intitated'}</Typography>
                            </Box>}
              </Box>
            )
          }
        }
      ]
      if (this.state.selectedBtn === 'request' && !fromBillMedication) {
        reqColumn?.push({
          field: 'action', headerName: 'Actions', flex: 0.143,
          renderCell: (params) => {
            return (
              <Box component={'div'}>
                <Button className="Common_Btn_Min_Width"
                  disabled={params?.row?.is_transmit}
                  onClick={() => this.handleEdit(params?.row, params?.row?.pharmacy_name, params?.row?.pharmacy_id)}
                >
                  <Box component={'img'} src={params?.row?.is_transmit ? ImagePaths.DisabledEdit.default : ImagePaths.Edit.default} height={'1.5dvw'} width={'1.5dvw'} alt="edit" />
                </Button>
                <Button className="Common_Btn_Min_Width"
                  disabled={params?.row?.is_transmit}
                  onClick={() => { this.handleDelete(params?.row) }}
                >
                  <Box component={'img'} src={params?.row?.is_transmit || this.state.isEdit ? ImagePaths.DisabledDelete.default : ImagePaths.Delete.default} height={'1.5dvw'} width={'1.5dvw'} alt="del" />
                </Button>
              </Box>
            )
          }
        })
      }

      const rtnColumn = [
        {
          field: 'bill_date', headerName: 'Date & Time', flex: 0.14,
          renderCell: (params) => {
            let date = params?.row?.bill_date
            return (
              <Box component={'div'}>
                {date ? date?.length > 10 ?
                  <Tooltip placement="top" title={date}><Typography>{date?.slice(0, 10) + '...'}</Typography></Tooltip> :
                  <Typography>{date}</Typography> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'brand_name', headerName: 'Brand Name', flex: 0.18,
          renderCell: (params) => {
            let brandName = params?.row?.brand_name
            let genStreName = params?.row?.generic_name + "|" + params?.row?.drug_strength
            let isHighAlert = params?.row?.is_high_alert && this.state.enable_drug_alert
            return (
              <Box component={'div'}>
                {brandName ? brandName?.length > 15 ?
                  <Tooltip placement="top" title={brandName}><Typography fontSize={'0.9rem'} fontWeight={600} color={isHighAlert ? 'error' : 'inherit'}>{brandName?.slice(0, 10) + '...'}</Typography></Tooltip> :
                  <Typography fontSize={'0.9rem'} fontWeight={600} color={isHighAlert ? 'error' : 'inherit'}>{brandName}</Typography> : '-'}
                {genStreName ? genStreName?.length > 15 ?
                  <Tooltip placement="top" title={genStreName}><Typography fontSize={'0.8rem'} color={isHighAlert ? 'error' : 'inherit'}>{genStreName?.slice(0, 15) + '...'}</Typography></Tooltip> :
                  <Typography fontSize={'0.8rem'} color={isHighAlert ? 'error' : 'inherit'}>{genStreName}</Typography> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'batch_details', headerName: 'Batch No / Bill No.', flex: 0.18,
          renderCell: (params) => {
            let batch = params?.row?.batch_no
            let billNo = params?.row?.bill_no
            return (
              <Box component={'div'}>
                {batch ? batch?.length > 10 ?
                  <Tooltip placement="top" title={batch}><Typography fontSize={'0.9rem'} fontWeight={600}>{batch?.slice(0, 10) + '...'}</Typography></Tooltip> :
                  <Typography fontSize={'0.9rem'} fontWeight={600}>{batch}</Typography> : '-'}
                {billNo ? billNo?.length > 20 ?
                  <Tooltip placement="top" title={billNo}><Typography fontSize={'0.8rem'}>{billNo?.slice(0, 20) + '...'}</Typography></Tooltip> :
                  <Typography fontSize={'0.8rem'}>{billNo}</Typography> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'received_quantity', headerName: 'Received/Requested Qty', flex: 0.16,
          renderCell: (params) => {
            let Req_qty = `${params?.row?.received_quantity} / ${params?.row?.quantity}`
            return (
              <Box component={'div'}>
                {Req_qty ? Req_qty?.length > 10 ?
                  <Tooltip placement="top" title={Req_qty}><Typography>{Req_qty?.slice(0, 10) + '...'}</Typography></Tooltip> :
                  <Typography>{Req_qty}</Typography> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'return_quantity', headerName: 'Return Qty', flex: 0.2,
          renderCell: (params) => {
            let rtn_qty = params?.row?.return_qty
            let qty = params?.row?.return_quantity
            return (
              <Box component={'div'}>
                <TextField
                  autoComplete="off"
                  sx={{ width: '5dvw' }}
                  inputProps={{
                    style: {
                      height: "2vw",
                      padding: '0 14px',
                    },
                  }}
                  size="small"
                  value={rtn_qty}
                  onChange={(e) => {
                    let value = e.target.value
                    if ((CommonValidation.numberOnly(value) && value <= params?.row?.received_quantity) || value === '') {
                      const medicationData = [...this.state.newMedicationReturnList]
                      medicationData[params?.row?.sno - 1] = { ...medicationData[params?.row?.sno - 1], return_qty: value }
                      this.setState({ newMedicationReturnList: medicationData })
                    } else {
                      this.errorMessage(`Receive Qty is ${params?.row?.received_quantity}`)
                    }
                  }}
                />
                <TextField
                  disabled
                  sx={{ width: '5dvw' }}
                  inputProps={{
                    style: {
                      height: "2vw",
                      padding: '0 14px',
                    }
                  }}
                  size="small"
                  value={qty}
                />
              </Box>
            )
          }
        },
        {
          field: 'nurse_name',
          headerName: 'Nurse',
          flex: 0.12,
          renderCell: (params) => {
            let nurseName = params?.row?.nurse_name
            return (
              <Box component={'div'}>
                {nurseName ? nurseName?.length > 15 ?
                  <Tooltip placement="top" title={nurseName}><Typography>{nurseName?.slice(0, 12) + '...'}</Typography></Tooltip> :
                  <Typography>{nurseName || '-'}</Typography> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'status', headerName: 'Status', flex: 0.14,
          renderCell: (params) => {
            let status = params?.row?.medication_status
            let rtn = params?.row?.return_quantity
            return (
              <Box>
                {params?.row?.external_drug_id ?
                  <Typography fontSize={'0.9dvw'} fontWeight={600}>External Drug</Typography> :
                  // status === 'Placed' ? <Box component={'div'} sx={{ backgroundColor: '#ffd192', border: '2px solid #de7c21', width: '7dvw', borderRadius: '5px', p: '0.3rem', textAlign: 'center' }}>
                  //   <Typography fontWeight={600} fontSize={'0.9rem'} color={'#de7c21'}>{'Inprogress'}</Typography>
                  // </Box> :
                  // status === 'Completely Received' && rtn === 0 ?
                  //   <Box component={'div'} sx={{ backgroundColor: '#de7c21', border: '2px solid #65a765', borderRadius: '5px', width: '7dvw', p: '0.3rem', textAlign: 'center' }}>
                  //     <Typography fontWeight={600} fontSize={'0.9rem'} color={'#65a765'}>{'Completed'}</Typography>
                  //   </Box> :
                  rtn !== 0 ?
                    <Box component={'div'} sx={{ backgroundColor: '#ffd192', border: '2px solid #de7c21', borderRadius: '5px', width: '6dvw', p: '0.3rem', textAlign: 'center' }}>
                      <Typography fontWeight={600} fontSize={'0.9rem'} color={'#de7c21'}>{'Return'}</Typography>
                    </Box> :
                    <Box component={'div'} sx={{ backgroundColor: '#90EE90', border: '2px solid #65a765', borderRadius: '5px', width: '6dvw', p: '0.3rem', textAlign: 'center' }}>
                      <Typography fontWeight={600} fontSize={'0.9rem'} color={'#65a765'}>{'Billed'}</Typography>
                    </Box>}
              </Box>
            )
          }
        },
      ]

      const calColumn = [
        {
          field: 'cancelled_date', headerName: 'Date & Time', flex: 0.143,
          renderCell: (params) => {
            let date = params?.row?.cancelled_date
            return (
              <Box component={'div'}>
                {date ? date?.length > 10 ?
                  <Tooltip placement="top" title={date}><Typography>{date?.slice(0, 10) + '...'}</Typography></Tooltip> :
                  <Typography>{date}</Typography> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'brand_name', headerName: 'Brand Name', flex: 0.143,
          renderCell: (params) => {
            let brandName = params?.row?.brand_name
            let genStreName = params?.row?.generic_name + "|" + params?.row?.drug_strength
            let isHighAlert = params?.row?.is_high_alert && this.state.enable_drug_alert
            return (
              <Box component={'div'}>
                {brandName ? brandName?.length > 15 ?
                  <Tooltip placement="top" title={brandName}>
                    <Typography fontSize={'0.9rem'} fontWeight={600} color={isHighAlert ? 'error' : 'inherit'}>
                      {brandName?.slice(0, 10) + '...'}
                    </Typography>
                  </Tooltip> :
                  <Typography fontSize={'0.9rem'} fontWeight={600} color={isHighAlert ? 'error' : 'inherit'}>
                    {brandName}
                  </Typography> : '-'}
                {genStreName ? genStreName?.length > 12 ?
                  <Tooltip placement="top" title={genStreName}>
                    <Typography fontSize={'0.8rem'} color={isHighAlert ? 'error' : 'inherit'}>
                      {genStreName?.slice(0, 12) + '...'}
                    </Typography>
                  </Tooltip> :
                  <Typography fontSize={'0.8rem'} color={isHighAlert ? 'error' : 'inherit'}>
                    {genStreName}
                  </Typography> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'medication', headerName: 'Route/Medication', flex: 0.143,
          renderCell: (params) => {
            let medication = params?.row?.tapper?.length > 0 ? 'Taper' : 'Regular'
            let route = params?.row?.route ? params?.row?.route : '-'
            return (
              <Box component={'div'}>
                {route ? route?.length > 15 ?
                  <Tooltip placement="top" title={route}><Typography fontSize={'0.9rem'} fontWeight={600}>{route?.slice(0, 10) + '...'}</Typography></Tooltip> :
                  <Typography fontSize={'0.9rem'} fontWeight={600}>{route}</Typography> : '-'}
                {medication ? medication?.length > 15 ?
                  <Tooltip placement="top" title={medication}><Typography fontSize={'0.8rem'}>{medication?.slice(0, 15) + '...'}</Typography></Tooltip> :
                  <Typography fontSize={'0.8rem'}>{medication}</Typography> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'morning', headerName: 'M-A-E-N/Duration', flex: 0.143,
          renderCell: (params) => {
            let maen = `${params?.row?.morning ? params?.row?.morning : '0'} - ${params?.row?.afternoon ? params?.row?.afternoon : '0'} - ${params?.row?.evening ? params?.row?.evening : '0'} - ${params?.row?.night ? params?.row?.night : '0'}`
            let durationDays = params?.row?.duration + ' ' + params?.row?.duration_type
            let tapperDetails = params?.row?.tapper
            return (
              params?.row?.tapper?.length === 0 ?
                <Box component={'div'}>
                  {maen ? maen?.length > 18 ?
                    <Tooltip placement="top" title={maen}><Typography fontSize={'0.9rem'} fontWeight={600}>{maen?.slice(0, 18) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9rem'} fontWeight={600}>{maen}</Typography> : '-'}
                  {durationDays ? durationDays?.length > 15 ?
                    <Tooltip placement="top" title={durationDays}><Typography fontSize={'0.8rem'}>{durationDays?.slice(0, 15) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.8rem'}>{durationDays}</Typography> : '-'}
                </Box> :
                <Box component={'div'}>
                  <Tooltip placement="top" arrow title={
                    tapperDetails?.map((item, index) => (
                      <Box component={'div'} key={index} fontSize={'0.8dvw'}>
                        <Typography fontSize={'0.8rem'} fontWeight={600}>{formatDate(item?.start_date?.slice(0, 10)) + ' - ' + formatDate(item?.end_date?.slice(0, 10))}</Typography>
                        <Typography fontSize={'0.8rem'}>{item?.duration}</Typography>
                      </Box>
                    ))
                  }>
                    {tapperDetails?.map((item, index) => {
                      let startEndDate = formatDate(item?.start_date?.slice(0, 10)) + ' - ' + formatDate(item?.end_date?.slice(0, 10))
                      return (
                        <Box component={'div'} key={index}>
                          <Typography fontSize={'0.8rem'} fontWeight={600}>{startEndDate?.slice(0, 16) + '...'}</Typography>
                          <Typography fontSize={'0.8rem'}>{item?.duration}</Typography>
                        </Box>
                      )
                    })}
                  </Tooltip>
                </Box>
            )
          }
        },
        {
          field: 'quantity', headerName: 'Requested Qty', flex: 0.143,
          renderCell: (params) => {
            let number_of_drugs = params?.row?.quantity
            return (
              <Box component={'div'}>
                {number_of_drugs ? number_of_drugs?.length > 10 ?
                  <Tooltip placement="top" title={number_of_drugs}><Typography>{number_of_drugs?.slice(0, 10) + '...'}</Typography></Tooltip> :
                  <Typography>{number_of_drugs}</Typography> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'nurse_name',
          headerName: 'Nurse',
          flex: 0.12,
          renderCell: (params) => {
            let nurseName = params?.row?.nurse_name
            return (
              <Box component={'div'}>
                {nurseName ? nurseName?.length > 15 ?
                  <Tooltip placement="top" title={nurseName}><Typography>{nurseName?.slice(0, 12) + '...'}</Typography></Tooltip> :
                  <Typography>{nurseName || '-'}</Typography> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'status', headerName: 'Status', flex: 0.143,
          renderCell: (params) => {
            let status = params?.row?.medication_status
            return (
              <Box>
                {status === 'Inprogress' ? <Box component={'div'} sx={{ backgroundColor: '#ffd192', border: '2px solid #de7c21', width: '7dvw', borderRadius: '5px', p: '0.3rem', textAlign: 'center' }}>
                  <Typography fontWeight={600} fontSize={'0.9rem'} color={'#de7c21'}>{'Inprogress'}</Typography>
                </Box> :
                  status === 'Billed' ?
                    <Box component={'div'} sx={{ backgroundColor: '#de7c21', border: '2px solid #65a765', borderRadius: '5px', width: '7dvw', p: '0.3rem', textAlign: 'center' }}>
                      <Typography fontWeight={600} fontSize={'0.9rem'} color={'#65a765'}>{'Completed'}</Typography>
                    </Box> :
                    status === 'Cancelled' ?
                      <Box component={'div'} sx={{ backgroundColor: '#ffefef', border: '2px solid #a80000', borderRadius: '5px', width: '7dvw', p: '0.3rem', textAlign: 'center' }}>
                        <Typography fontWeight={600} fontSize={'0.9rem'} color={'#a80000'}>{'Cancelled'}</Typography>
                      </Box> :
                      status === 'Saved' ?
                        <Box component={'div'} sx={{ backgroundColor: '#e6e6e6', border: '2px solid #a1a1a1', borderRadius: '5px', width: '7dvw', p: '0.3rem', textAlign: 'center' }}>
                          <Typography fontWeight={600} fontSize={'0.9rem'} color={'#808080'}>{'Saved'}</Typography>
                        </Box> :
                        status === 'Transmitted' ?
                          <Box component={'div'} sx={{ backgroundColor: '#e6e6e6', border: '2px solid #a1a1a1', borderRadius: '5px', width: '7dvw', p: '0.3rem', textAlign: 'center' }}>
                            <Typography fontWeight={600} fontSize={'0.9rem'} color={'#808080'}>{'Transmitted'}</Typography>
                          </Box> :
                          <Box component={'div'} sx={{ backgroundColor: '#e6e6e6', border: '2px solid #a1a1a1', borderRadius: '5px', width: '7dvw', p: '0.3rem', textAlign: 'center' }}>
                            <Typography fontWeight={600} fontSize={'0.9rem'} color={'#808080'}>{'Not Intitated'}</Typography>
                          </Box>}
              </Box>
            )
          }
        }
      ]
      return (
        <Box component={'div'}>
          <Box component={'div'} p={'0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
            <Box component={'div'}>
              <ButtonGroup>
                <Button variant={this.state.selectedBtn === 'request' ? "contained" : 'outlined'}
                  sx={{ textTransform: 'capitalize' }}
                  onClick={() => this.setState({ selectedBtn: 'request' }, () => { this.clearTemplateStates() })}
                >Request</Button>
                <Button variant={this.state.selectedBtn === 'billed' ? "contained" : 'outlined'}
                  sx={{ textTransform: 'capitalize' }}
                  onClick={() => this.setState({ selectedBtn: 'billed' }, () => { this.clearTemplateStates() })}
                >Billed</Button>
                <Button variant={this.state.selectedBtn === 'cancelled' ? "contained" : 'outlined'}
                  sx={{ textTransform: 'capitalize' }}
                  onClick={() => this.setState({ selectedBtn: 'cancelled' }, () => { this.clearTemplateStates() })}
                >Cancelled</Button>
              </ButtonGroup>
            </Box>
            <Box display={'flex'} flexDirection={'row'} alignItems={'center'} gap={'0.625vw'}>
               {this.state.selectedBtn === 'request' && this.state.newMedicationRequestList.some(item => item.medication_status === 'Transmitted') && <Tooltip
                placement='top' title='Recall Drug List'>
                <IconButton
                  variant="contained"
                  size="small"
                  sx={{ textTransform: 'capitalize', cursor: 'pointer', width: '2vw', height: '2vw' }}
                  onClick={() => {
                    this.setState({
                      showRecallDialog: true,
                      recallSelectedIds: [],
                      recallReason: '',
                      recallMedicationList: [],
                      recallIsAllSelected: false
                    })
                    }}
                >
                  <div style={{ backgroundColor: "#b8170d", borderRadius: "0vw" }}>
                  <img src={ImagePaths.Recall.default} style={{height:'1.7vw', width:'1.7vw'}} alt="Recall Drug List" />
                  </div>
                </IconButton>
              </Tooltip>}
              {this.state.selectedBtn === 'request' && this.renderTemplate()}
              {fromBillMedication || this.state.selectedBtn === 'cancelled' ? null : <Box component={'div'}>
                <Button variant="contained"
                  size="small"
                  disabled={checkUserAccess}
                  sx={{ textTransform: 'capitalize' }}
                  startIcon={<CompareArrowsIcon fontSize="small" />}
                  onClick={() => { this.state.selectedBtn === 'request' ? this.handleMedicTransmit() : this.handleMedicSave() }}
                >{this.state.selectedBtn === 'request' ? `Transfer Drugs (${this.state.transmitData?.length})` :
                  this.state.selectedBtn === 'billed' ? `Return Drugs (${this.state.returnData?.length})` : ''}</Button>
              </Box>}
              {this.state.selectedBtn === 'request' && <img src={ImagePaths.LabPrintIcon.default} alt='print'
                style={{ width: '2vw', height: '2vw', cursor: 'pointer' }}
                onClick={() => this.getMedicationPrint()} />}
            </Box>
          </Box>
          <Box component={'div'} height={'56.5dvh'}>
            {this.state.selectedBtn === 'request' ?
              <DataGrid
                checkboxSelection={fromBillMedication ? false : true}
                onSelectionModelChange={(ids) => {
                  const selectedIds = new Set(ids)
                  const selectedRows = this.state.newMedicationRequestList?.filter((row) => selectedIds.has(row.sno))
                  this.setState({ transmitData: selectedRows })
                }}
                isRowSelectable={(params) => {
                  if (params?.row?.external_drug_id) {
                    return false
                  } else {
                    return !params.row.is_transmit
                  }
                }}
                columns={reqColumn}
                rows={this.state.newMedicationRequestList}
                getRowId={(row) => row['sno']}
                page={this.state.page}
                pageSize={this.state.pageSize}
                localeText={{
                  toolbarColumns: "",
                  toolbarDensity: "",
                  toolbarExport: "",
                  toolbarFilters: "",
                  toolbarExportPrint: ""
                }}
                components={{
                  // Toolbar: CommonGridHeader.CommonToolBar,
                  NoRowsOverlay: () => (
                    <Box className='' sx={{ position: 'relative', top: '8vw', left: '23vw' }}>
                      {'No Records To Be Shown'}
                    </Box>
                  )
                }}
                onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                rowsPerPageOptions={[10, 20, 30]}
                pagination
                headerHeight={40}
                disableSelectionOnClick
                loading={this.state.loading}
                getRowHeight={(params) => {
                  const tapperLength = params.model.tapper.length;
                  if (tapperLength > 1) {
                    const baseHeight = 50; // Base height for rows
                    const additionalHeight = tapperLength * 35; // Add height per `tapper` element
                    return baseHeight + additionalHeight;
                  }
                }}
              /> : this.state.selectedBtn === 'cancelled' ?
                <DataGrid
                  columns={calColumn}
                  rows={this.state.newMedicationCancelledList}
                  getRowId={(row) => row['sno']}
                  page={this.state.calPage}
                  pageSize={this.state.calPageSize}
                  localeText={{
                    toolbarColumns: "",
                    toolbarDensity: "",
                    toolbarExport: "",
                    toolbarFilters: "",
                    toolbarExportPrint: ""
                  }}
                  components={{
                    // Toolbar: CommonGridHeader.CommonToolBar,
                    NoRowsOverlay: () => (
                      <Box className='' sx={{ position: 'relative', top: '8vw', left: '23vw' }}>
                        {'No Records To Be Shown'}
                      </Box>
                    )
                  }}
                  onPageChange={(newPage) => { this.setState({ calPage: newPage }) }}
                  onPageSizeChange={(newPageSize) => this.setState({ calPageSize: newPageSize })}
                  rowsPerPageOptions={[10, 20, 30]}
                  pagination
                  headerHeight={40}
                  disableSelectionOnClick
                  loading={this.state.loading}
                /> : <DataGrid
                  checkboxSelection={fromBillMedication ? false : true}
                  onSelectionModelChange={(ids) => {
                    const selectedIds = new Set(ids)
                    const selectedRows = this.state.newMedicationReturnList?.filter((row) => selectedIds.has(row.sno))
                    this.setState({ returnData: selectedRows })
                  }}
                  isRowSelectable={(params) => { return params?.row?.return_qty ? true : false }}
                  columns={rtnColumn}
                  rows={this.state.newMedicationReturnList}
                  getRowId={(row) => row['sno']}
                  page={this.state.rtnPage}
                  pageSize={this.state.rtnPageSize}
                  localeText={{
                    toolbarColumns: "",
                    toolbarDensity: "",
                    toolbarExport: "",
                    toolbarFilters: "",
                    toolbarExportPrint: ""
                  }}
                  components={{
                    // Toolbar: CommonGridHeader.CommonToolBar,
                    NoRowsOverlay: () => (
                      <Box className='' sx={{ position: 'relative', top: '8vw', left: '23vw' }}>
                        {'No Records To Be Shown'}
                      </Box>
                    )
                  }}
                  onPageChange={(newPage) => { this.setState({ rtnPage: newPage }) }}
                  onPageSizeChange={(newPageSize) => this.setState({ rtnPageSize: newPageSize })}
                  rowsPerPageOptions={[10, 20, 30]}
                  pagination
                  headerHeight={40}
                  disableSelectionOnClick
                  loading={this.state.loading}
                />}
          </Box>
        </Box>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  render() {    
    const { t, fromBillMedication } = this.props;
    let states = this.state;
    let UserData = JSON.parse(localGetItem("loggedInUserInfo"));
    let { mediItem } = this.state;
    let disable = (states["pharma_name"] === "" || ((mediItem["drug_ms_id"] !== "") && (mediItem["dosage_type"]) === 'Steroid Tablets' || (mediItem["dosage_type"]) === "Drop"));

    let data = {
      lineOne: fromBillMedication ? t("Emergency Contact") : t("AttenderName"),
      lineTwo: `${states["attenderData"]["attender_name"] ? states["attenderData"]["attender_name"] : "-"}`,
      lineFour: t('ContactNumber'),
      LineFive: `${states["attenderData"]["attender_mobile"] ? states["attenderData"]["attender_mobile"] : "-"}`
    }

    let Consultant = {
      image: ImagePaths.Doctor_Icon.default,
      width: "2.3vw",
      height: "2.3vw",
      lineOne: t("ConsultantName"),
      lineTwo: `${states["attenderData"]["doctor_name"] ? states["attenderData"]["doctor_name"] : "-"}`
    }
    return (
      <Box id={fromBillMedication ? "eMed_AdHistory_Container" : "eMed_medication_Container"} sx={{ backgroundColor: Colors.configHomeBg }}>
        <Grid container className="eMed_medication_Box" >
          <Stack className="eMed_medicationCard_header" direction="row" justifyContent="space-evenly" alignItems="center" spacing={1.2} >
            <Stack className="eMed_recCard_div" sx={{ width: "23vw", backgroundColor: Colors.white }} >
              <CommonPatientDetails data={this.state.patientData} showDetailed={!fromBillMedication} />
            </Stack>
            <CommonPatientCard details={data} showDetailed={true} />
            {fromBillMedication ? null : <ConsultantPatientCard name={Consultant} width={"20dvw"} />}
            <Box width={'15vw'} height={'4.5vh'} marginBottom={'1vw'}>
              <CommonDatePicker
                FromDate={this.state.fromDate}
                ToDate={this.state.toDate}
                DateIndex={this.state.dateIndex}
                SelectedDates={this.FilterDate.bind(this)}
                OutOfOffice={true}
                removeMarginRight={true}
                FromDateOpen={this.state.patientData.admission_date || null}
                ToDateOpen={this.state.patientData.discharge_date || null} />
            </Box>
          </Stack>
          <Grid container item spacing={2} className="eMed_medication_mainDiv">
            <Grid item xs={fromBillMedication ? 12 : 8}>
              <Paper className="eMed_medication_Div" elevation={fromBillMedication ? 0 : 2}>
                {this.renderLeftMedicationScreen()}
              </Paper>
            </Grid>
            {fromBillMedication ? null :
              <Grid item xs={4}>
                <Paper className="eMed_medication_Div" elevation={2}>
                  <div className='eMed_medication_rightHead' style={{ backgroundColor: Colors.DataTblHeaderbg }}>
                    <p className='eMed_recPayment_rightHead_txt'>{t("DetailsForDrug")}</p>
                    {this.renderTextBox("SelectPharmacy", "pharma_name", states["pharma_name"], "14vw")}
                  </div>
                  <div className="eMed_medication_subDiv" style={{ overflowX: 'hidden'}} >
                    <Box sx={{ display: 'flex', justifyContent: "flex-end", marginRight: "0.5vw" }}>
                      <Button size="small" variant="outlined" onClick={() => { this.setState({ ExternalDrug: !this.state.ExternalDrug }, () => this.clearOnChange()) }}>{this.state.ExternalDrug ? "Phramacy Drugs" : "External drugs"}</Button>
                    </Box>
                    <Stack className="emedhub_medication_RightContentBox" direction="column" justifyContent="center" alignItems="center" spacing={0.5}>
                      {
                        this.state.ExternalDrug ?
                          <>
                            {this.renderFreeTextField("BrandName", "externalBrandName", "externalBrandName", "27.5vw")}
                            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1.5}>
                              {this.renderFreeTextField("GenericName", "externalGenName", "externalGenName", "13.4vw")}
                              {this.renderFreeTextField("DosageType", "externalDosageType", "externalDosageType", "13.2vw")}
                            </Stack>
                            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1.5}>
                              {this.renderFreeTextField("DosageStrength", "externalDosStrength", "externalDosStrength", "13.4vw")}
                              {this.renderFreeTextField("Route", "externalRoute", "externalRoute", "13.2vw")}
                            </Stack>
                            <Stack direction="row" justifyContent="space-between" alignItems="center" width={'100%'}>
                              <TextField
                                sx={{ marginLeft: '15vw', width: "10vw", display: this.state.externalRoute === "Others" ? 'block' : "none" }}
                                size="small"
                                autoComplete="off"
                                label={t("Route")}
                                value={this.state.externalRouteOther}
                                onChange={(e) => {
                                  let states = this.state
                                  states["externalRouteOther"] = e.target.value
                                  this.setState({
                                    states
                                  })
                                }}
                              />
                            </Stack>
                          </>
                          :
                          <>
                            {this.renderTextBox("BrandName", "brand_name", mediItem["brand_name"], "27.5vw")}

                            {states["frequentDrugs"].length > 0 ?
                              <Stack id="eMed_medication_chipDiv" direction="row" justifyContent="flex-start" alignItems="center" spacing={1} flexWrap="wrap">
                                {states["frequentDrugs"].map((item, i) => {
                                  if (item["drug_name"] !== "") {
                                    return (<Chip key={i} id="eMed_medication_chip" label={item.drug_name} sx={{ '& .MuiChip-label': { fontSize: "0.8vw" }, '&.MuiChip-icon': { width: "1.5vw", height: "1.5vw" } }}
                                      color={states["pharma_name"] !== "" ? 'primary' : "default"} variant={states["mediItem"]["brand_name"] === item.drug_name ? 'contained' : "outlined"} onClick={() => states["pharma_name"] !== "" ? this.handleChipClk(item) : ""} />)
                                  }
                                })}
                              </Stack> : null}
                            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1.5}>
                              {this.renderTextBox("GenericName", "generic_name", mediItem["generic_name"], "13.4vw")}
                              {this.renderTextBox("DosageType", "dosage_type", mediItem["dosage_type"], "13.2vw")}
                            </Stack>
                            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1.5} marginBottom={"0.5vw"}>
                              {this.renderTextBox("DosageStrength", "dosage_strength", mediItem["dosage_strength"], "13.4vw")}
                              {this.renderTextBox("Route", "route", mediItem["route"], "13.2vw")}
                            </Stack>
                            <Stack direction="row" justifyContent="space-between" alignItems="center" width={'100%'}>
                              <TextField
                                sx={{ marginLeft: '15vw', width: "10vw", display: mediItem["route"] === "Others" ? 'block' : "none" }}
                                size="small"
                                autoComplete="off"
                                label={t("Route")}
                                value={this.state.mediRouteOther}
                                onChange={(e) => {
                                  let states = this.state
                                  states["mediRouteOther"] = e.target.value
                                  this.setState({
                                    states
                                  })
                                }}
                              />
                            </Stack>
                          </>
                      }
                      {(!states["isTapper"]) ?
                        <Stack className="eMed_medication_maenDiv" sx={{height:'30vh'}} direction="column" justifyContent="center" alignItems="flex-start" spacing={1.2}>
                          <Typography sx={{ fontSize: "1vw", marginBottom: "0.5vw" }}> {t("MAEN Dosage Quantity")}
                            {!this.state.isTapper && !disallowed.has(this.state.instruction) ? "*" : ""}
                          </Typography>
                          {this.renderMaen("Morning", "morning")}
                          {this.renderMaen("Afternoon", "afternoon")}
                          {this.renderMaen("Evening", "evening")}
                          {this.renderMaen("Night", "night")}
                        </Stack>
                        : null}
                      <ButtonGroup disableElevation className="eMed_medication_btnDiv">
                        <Button disabled={this.state.withOutAppointment?.is_ip} variant={states["isTapper"] ? "outlined" : "contained"} id="eMed_medication_btn" onClick={() => this.setState({ isTapper: false })}>{t("Normal")}</Button>
                        <Button disabled={this.state.withOutAppointment?.is_ip} variant={states["isTapper"] ? "contained" : "outlined"} id="eMed_medication_btn" onClick={() => ((states["mediItem"]["drug_ms_id"] !== "" && states["pharma_name"] !== "") && ((mediItem["drug_ms_id"] !== "") && (mediItem["dosage_type"]) === 'Steroid Tablets' || (mediItem["dosage_type"]) === "Drop" || ((mediItem["dosage_type"])?.toLowerCase()?.includes('drops')))) ? this.setState({ isTapper: true }) : null}>{("Taper")}</Button>
                      </ButtonGroup>
                    </Stack>
                    <Box>
                      {(localGetItem('show_selective_days_in_prescription') === "true") ? (
                        <FormControl sx={{ m: 1, width: '27.5vw' }} size="small" >
                          <InputLabel >Select Days</InputLabel>
                          <Select
                            multiple
                            size="small"
                            value={this.state?.Selected_days}
                            onChange={this.DropdownHandleChange}
                            input={<OutlinedInput label="Select Days" />}
                          >
                            {Prescription_Days.map((days) => (
                              <MenuItem
                                key={days}
                                value={days}
                              >
                                {days}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      ) : null}
                    </Box>
                    {/* Add Nurse Dropdown */}
                    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1.5} sx={{ width: '100%', margin: '0.6vw' }}>
                      <Autocomplete
                        size='small'
                        sx={{ width: "27.5vw" }}
                        options={this.state.nurseList}
                        getOptionLabel={(option) => {
                          if (typeof option === 'string') return option;
                          return option.nurse_name || 'Unknown Nurse';
                        }}
                        value={this.state.selectedNurse}
                        onChange={(event, newValue) => {
                          console.log('Selected Nurse:', newValue);
                          this.setState({
                            selectedNurse: newValue,
                            nurseName: newValue?.nurse_name || ""
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Nurse*"
                            autoComplete="off"
                            placeholder={this.state.nurseList.length === 0 ? "Loading nurses..." : "Choose a nurse"}
                          />
                        )}
                        noOptionsText="No nurses available"
                      />
                    </Stack>
                    {this.renderTapper()}
                    <Stack className="emedhub_recPayment_RightContentBox" direction="column" justifyContent="center" alignItems="flex-start" spacing={1}>
                      <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
                        {this.renderTextBox("Quantity", "quantity", states["quantity"], "13.2vw")}
                        {mediItem["drug_ms_id"] && <p style={{ color: +mediItem["stock_in_quantity"] === 0 ? 'red' : 'black' }}>{`${t("stockInQty")} : ( ${mediItem["stock_in_quantity"] ? mediItem["stock_in_quantity"] : 0} )`}</p>}
                      </Stack>
                       {(!states["isTapper"]) ?
                        <Stack id="eMed_medication_instruDiv" direction="row" justifyContent="space-between" alignItems="center" >  
                          {this.renderInstructionAutocomplete()}
                        </Stack> : null}
                    </Stack>
                  </div>
                  <Stack spacing={2} direction="row" id='eMed_recPayment_rightBtnCon' sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center">
                    <Button variant='outlined' disabled={this.state.withOutAppointment?.is_ip} size="small" id="eMed_recPayment_btn"
                      onClick={() => {
                        // this.setState({
                        //   pharma_name: "",
                        //   pharma_id: null,
                        // })
                        this.handleClear()
                      }}>{t("Clear")}</Button>
                    <Button disabled={this.props.is_From_IpNotes ? false :
                      (CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Medication", "SubTab")?.editAccess ? this.state.withOutAppointment?.is_ip : true) || this.state.isAdd}
                      variant='contained' size="small" id="eMed_recPayment_btn"
                      onClick={() => {
                        this.setState({ isAdd: true, },
                          () => { this.handleAdd() })
                      }}>{t("Add")}</Button>
                  </Stack>
                </Paper>
              </Grid>}
          </Grid>
        </Grid>
        {!(this.state.isEdit) && this.state.deletedPopup ?
          <DeletePopup DeletTitle={`${t("deleteMsg")}  ${states["brand_name"] ? states["brand_name"] : "-"} ?`}
            deleteAlertPopupClose={this.PopupClose.bind(this)}
            removeData={this.removeDataList.bind(this)}
          />
          : null}
        {
          this.state.successMsg ? <ToastMsg severity={"success"} msg={this.state.successMsgText} msgPop={this.msgClose.bind(this)} /> : null
        }
        {
          this.state.showSuccessResponse ? <ToastMsg severity={"success"} msg={this.state.responseMessage} msgPop={this.msgClose.bind(this)} /> : null
        }
        {
          this.state.showErrorResponse  ? <ToastMsg severity={"error"} msg={this.state.responseMessage} msgPop={this.msgClose.bind(this)} /> : null
        }
        {
          this.state.isErrorMsg ? <ToastMsg severity={"error"} msg={this.state.isErrorMsgText} msgPop={this.msgClose.bind(this)} /> : null
        }
        {
          states["selectedOption"] === "Medication" ?
            <CommonPopUp width={"75vw"} popUpClose={this.MedicPopUpClose.bind(this)} title={t("Medication")} component={this._showReturnDetails.bind(this)} buttonOne={t("Clear")}
              buttonOneAction={this.MedicPopUpClear.bind(this)} buttonTwo={t("Save")} buttonTwoAction={this.handleMedicSave.bind(this)} />
            : null
        }
        {
          states["isHistoryClicked"] ?
            <CommonPopUp width={"75vw"} backgroundColor={Colors.white} popUpClose={this.historyPopUpClose.bind(this)} title={t("History")} component={this._showHistory.bind(this, states["historyData"])} />
            : null
        }
        {this.renderTemplatePopup()}
        {this.renderNewUsagePopup()}
        {this.state.showRecallDialog ? this.recallDrugList() : null}
        {this.state.deletePopup ? <DeletePopup
          DeletTitle={`Are you sure you want to delete ${this.state.tempType === 'delete' ? this.state.deleteTemplateName?.template_name : ''} ?`}
          deleteAlertPopupClose={() => this.setState({ deletePopup: false, deleteTemplateName: {} })}
          removeData={this.deleteTemplate.bind(this)}
          disable={this.state.deleteLoad}
        /> : null}
        {this.state.highAlert && this.state.enable_drug_alert?
          <HighAlertDrugPopup
            selectedDrug={this.state.selectedDrug}
            is_high_alert={this.state.is_high_alert}
            is_lookAlike={this.state.is_look_alike}
            is_soundAlike={this.state.is_sound_alike}
            lookAlikeDrugs={this.state.lookAlikeDrugs}
            soundAlikeDrugs={this.state.SoundAlikeDrugs}
            onCancel={this.highAlertpopupClose.bind(this)}
            onConfirm={this.highAlertpopupConfirm.bind(this)}
            onOk={this.highAlertpopupOk.bind(this)}
            allData={this.state.AllData}
            onlyWarning={this.state.onlyWarning}
          /> : null}
        <Loader loaderOpen={this.state.isLoader} />
      </Box>
    )
  }
}
export default withTranslation()(Medication);